import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  et: {
    translation: {
      // Header
      "catalog": "Kataloog",
      "categories": "Kategooriad",
      "allProducts": "Kõik tooted",
      "orders": "Tellimused",
      "dashboard": "Juhtpaneel",
      "products": "Tooted",
      "clients": "Kliendid",
      "cart": "Ostukorv",
      "profile": "Profiil",
      "logout": "Logi välja",
      "login": "Logi sisse",
      "basicInfo": "Põhiline info",
      "addBox": "Lisa kast",
      "yourPersonalDiscountApplied": "Sinu isiklik allahindlus on rakendatud",
      "generalDiscountApplied": "Üldine allahindlus on rakendatud",
      "yourPersonalDiscount": "Sinu isiklik allahindlus",
      "yourPersonalDiscountUnit": "Sinu isiklik allahindlus ühikul",
      "generalDiscount": "Üldine allahindlus",
      "orderInfo": "Tellimuse info",
      "backToOrders": "Tagasi tellimustele",
      "contact": "Kontakt",
      "productsInOrder": "Tellitud tooted",
      "waitsForConfirmation": "Ootab kinnitust",
      "language": "et",
      "item": "Toode",
      "statusHistory": "Staatusi ajalugu",
      "orderPlacedSuccess": "Tellimus edukalt esitatud",
      "orderEditedByAdmin": "Tellimust muutis administraator",
      "subTotal": "Vahesumma",
      "order": "Tellimus",
      "city": "Linn",
      "postalCode": "Postiindeks",
      "country": "Riik",
      "firstName": "Eesnimi",
      "lastName": "Perekonnanimi",
      "deliveryRules": "Tarneaeg",
      "deliveryDays": "Tarneaeg",
      "monday": "Esmaspäev",
      "tuesday": "Teisipäev",
      "wednesday": "Kolmapäev",
      "thursday": "Neljapäev",
      "friday": "Reede",
      "saturday": "Laupäev",
      "sunday": "Pühapäev",
      "security": "Turvalisus",
      "noDescription": "Kirjeldust ei ole",
      "nutritionalValue": "Toiduaine",
      "back": "Tagasi",
      "calories": "Kalorid",
      "protein": "Proteiin",
      "fat": " Rasvhappe",
      "carbohydrates": "Süsivesikud",
      "fiber": "Vellus",
      "servingSize": "Portsi suurus",
      "caloriesUnit": "kcal",
      "g": "g",
      "completed": "Lõpetatud",
      "rejected": "Tagasi lükatud",
      "repeatOrder": "Korda tellimust",
      "boxSales": "Kastide müük",
      "inBox": "Kastis",
      "boxPrice": "Kasti hind",
      "boxQuantity": "Kasti kogus",
      "noOrders": "Teil pole veel tellimusi",
      "inCart": "Ostukorvis",
      "loginError": "Sisselogimine ebaõnnestus",
      "invalidCredentials": "Vale kasutajatunnus või parool",
      "errorLoadingOrders": "Tellige laadimine ebaõnnestus",
      // Catalog
      "productCatalog": "Tootekataloog",
      "searchProducts": "Otsi tooteid...",
      "sortByName": "Nime järgi",
      "sortByPriceAsc": "Hind: kasvav",
      "sortByPriceDesc": "Hind: kahanev",
      "loadingProducts": "Laen tooteid...",
      "noProductsFound": "Tooteid ei leitud",
      "errorLoadingProducts": "Toodete laadimine ebaõnnestus",
      
      // Cart
      "yourCart": "Teie ostukorv",
      "cartEmpty": "Teie ostukorv on tühi",
      "addFromCatalog": "Lisa tooteid kataloogist",
      "goToCatalog": "Mine kataloogi",
      "clearCart": "Tühjenda ostukorv",
      "itemsInCart": "Tooteid ostukorvis:",
      "total": "Kokku:",
      "checkout": "Vormista tellimus",
      "remove": "Eemalda",
      "box": "Kast",
      "pieces": "tk",
      "minimumOrderWarning": "Minimaalne tellimuse summa: {{amount}}€",
      "addMoreProducts": "Lisa veel {{amount}}€ väärtuses tooteid",
      "priceDisclaimer": "Lõplik hind võib sõltuda komplekteerimisest.<br/>Summale lisatakse käibemaks.",
      "orderHasNoItems": "Tellimus ei sisalda tooteid",
      "addedToCart": "Lisatud ostukorvi",
      "items": "toodet",
      "unavailable": "Pole saadaval",
      "allItemsUnavailable": "Kahjuks pole kõik tellimuses olevad tooted praegu saadaval",
      "repeatOrderFailed": "Tellimuse kordamine ebaõnnestus",
      
      // Units
      "kg": "kg",
      "piece": "tk",
      "boxUnit": "kast",
      "step": "samm",
      "multiplicity": "Kordus",
      
      // Login
      "welcomeMessage": "Toidu transport restoranidele",
      "loginTitle": "Logi sisse süsteemi",
      "email": "E-post",
      "password": "Parool",
      "loginButton": "Logi sisse",
      "loggingIn": "Sisselogimine...",
      "testCredentials": "Testmandaadid:",
      "admin": "Administraator",
      "client": "Klient",
      
      // Footer
      "privacyPolicy": "Privaatsuspoliitika",
      "allRightsReserved": "Kõik õigused kaitstud",
      
      // Common
      "loading": "Laadimine...",
      "error": "Viga",
      "success": "Õnnestus",
      "save": "Salvesta",
      "cancel": "Tühista",
      "delete": "Kustuta",
      "edit": "Muuda",
      "add": "Lisa",
      "search": "Otsi",
      "filter": "Filtreeri",
      "sort": "Sorteeri",
      "price": "Hind",
      "quantity": "Kogus",
      "description": "Kirjeldus",
      "category": "Kategooria",
      "status": "Staatus",
      "actions": "Tegevused",
      "confirm": "Kinnita",
      "close": "Sulge",
      
      // Product Details
      "productDetails": "Toote üksikasjad",
      "addToCart": "Lisa ostukorvi",
      "inStock": "Laos",
      "outOfStock": "Otsas",
      "selectUnit": "Vali ühik",
      "perPiece": "Tükk",
      "perBox": "Kast",
      "discount": "Allahindlus",
      "originalPrice": "Algne hind",
      "finalPrice": "Lõplik hind",
      
      // Orders
      "myOrders": "Minu tellimused",
      "orderNumber": "Tellimus nr",
      "orderDate": "Tellimuse kuupäev",
      "orderStatus": "Staatus",
      "orderTotal": "Summa",
      "viewDetails": "Vaata üksikasju",
      "orderDetails": "Tellimuse üksikasjad",
      "deliveryAddress": "Tarneaadress",
      "deliveryDate": "Tarnekuupäev",
      "orderItems": "Tellitud tooted",
      "itemsCount": "Toodete arv",
      
      // Order Statuses
      "pending": "Ootel",
      "confirmed": "Kinnitatud",
      "processing": "Töötlemisel",
      "shipped": "Saadetud",
      "delivered": "Kohale toimetatud",
      "cancelled": "Tühistatud",
      
      // Checkout
      "checkoutTitle": "Tellimuse vormistamine",
      "deliveryInfo": "Tarneinfo",
      "deliveryDateLabel": "Tarnekuupäev",
      "deliveryAddressLabel": "Tarneaadress",
      "notes": "Märkused",
      "orderSummary": "Tellimuse kokkuvõte",
      "subtotal": "Vahesumma",
      "deliveryFee": "Tarne",
      "placeOrder": "Esita tellimus",
      "yourOrder": "Teie tellimus",
      "deliveryDetails": "Tarneandmed",
      "additionalInfo": "Lisateave",
      "orderComments": "Tellimuse kommentaarid...",
      "selectDate": "Vali kuupäev",
      "submitting": "Esitamine...",
      "submitOrder": "Esita tellimus",
      
      // Profile
      "myProfile": "Minu profiil",
      "restaurantName": "Restorani nimi",
      "contactPerson": "Kontaktisik",
      "phone": "Telefon",
      "address": "Aadress",
      "updateProfile": "Uuenda profiili",
      "changePassword": "Muuda parooli",
      "currentPassword": "Praegune parool",
      "newPassword": "Uus parool",
      "confirmPassword": "Kinnita parool",
      "street": "Tänav",
      
      // Admin Dashboard
      "adminDashboard": "Administraatori juhtpaneel",
      "statistics": "Statistika",
      "totalOrders": "Tellimusi kokku",
      "totalRevenue": "Käive kokku",
      "totalProducts": "Tooteid kokku",
      "totalUsers": "Kasutajaid kokku",
      "recentOrders": "Viimased tellimused",
      "topProducts": "Populaarsed tooted",
      
      // Admin Products
      "manageProducts": "Halda tooteid",
      "addProduct": "Lisa toode",
      "editProduct": "Muuda toodet",
      "deleteProduct": "Kustuta toode",
      "productName": "Toote nimi",
      "productImage": "Toote pilt",
      "productPrice": "Hind",
      "productStock": "Laoseis",
      "productCategory": "Kategooria",
      "productActive": "Aktiivne",
      "uploadImage": "Laadi pilt üles",
      "searchProducts2": "Otsi tooteid...",
      "importCategories": "Impordi kategooriad",
      "importProducts": "Impordi tooteid",
      "image": "Pilt",
      "name": "Nimi",
      "sortByDiscount": "Sorteeri allahindluse järgi",
      "sortByPopularity": "Sorteeri populaarsuse järgi",
      "sortByStock": "Sorteeri laoseisu järgi",
      "popularity": "Populaarsus",
      "stock": "Ladu",
      "unit": "Ühik",
      "allCategories": "Kõik kategooriad",
      
      // Admin Orders
      "manageOrders": "Halda tellimusi",
      "updateStatus": "Uuenda staatust",
      "orderHistory": "Tellimuste ajalugu",
      "customer": "Klient",
      "paymentStatus": "Makse staatus",
      "paid": "Makstud",
      "unpaid": "Maksmata",
      "searchOrders": "Otsi numbri või kliendi järgi...",
      "orderNumber2": "Number",
      "createdDate": "Loomise kuupäev",
      "delivery": "Kohaletoimetamine",
      "itemsCount2": "Kaupu",
      "amount": "Summa",
      "viewDetails2": "Vaata detaile",
      "changeStatus": "Muuda staatust",
      "changeOrderStatus": "Muuda tellimuse staatust #",
      "currentStatus": "Praegune staatus",
      "newStatus": "Uus staatus",
      "commentOptional": "Kommentaar (valikuline)",
      "allOrders": "Kõik tellimused",
      "pendingOrders": "Ootavad kinnitust",
      "confirmedOrders": "Kinnitatud",
      "processingOrders": "Töötlemisel",
      "completedOrders": "Lõpetatud",
      "cancelledOrders": "Tühistatud",
      "rejectedOrders": "Tagasi lükatud",
      
      // Admin Users
      "manageUsers": "Halda kliente",
      "addUser": "Lisa klient",
      "editUser": "Muuda klienti",
      "deleteUser": "Kustuta klient",
      "userName": "Nimi",
      "userEmail": "E-post",
      "userRole": "Roll",
      "userStatus": "Staatus",
      "active": "Aktiivne",
      "inactive": "Mitteaktiivne",
      "personalDiscount": "Isiklik allahindlus",
      
      // Validation Messages
      "fieldRequired": "See väli on kohustuslik",
      "invalidEmail": "Vigane e-posti aadress",
      "passwordTooShort": "Parool peab olema vähemalt 6 tähemärki",
      "passwordsNotMatch": "Paroolid ei kattu",
      "invalidPrice": "Vigane hind",
      "invalidQuantity": "Vigane kogus",
      
      // Success Messages
      "productAdded": "Toode lisatud ostukorvi",
      "orderPlaced": "Tellimus esitatud",
      "profileUpdated": "Profiil uuendatud",
      "passwordChanged": "Parool muudetud",
      "productCreated": "Toode loodud",
      "productUpdated": "Toode uuendatud",
      "productDeleted": "Toode kustutatud",
      
      // Error Messages
      "generalError": "Midagi läks valesti",
      "networkError": "Võrguühenduse viga",
      "unauthorized": "Volitamata juurdepääs",
      "notFound": "Ei leitud",
      "serverError": "Serveri viga"
    }
  },
  en: {
    translation: {
      // Header
      "catalog": "Catalog",
      "categories": "Categories",
      "allProducts": "All products",
      "orders": "Orders",
      "dashboard": "Dashboard",
      "products": "Products",
      "clients": "Clients",
      "cart": "Cart",
      "profile": "Profile",
      "logout": "Logout",
      "login": "Login",
      "basicInfo": "Basic information",
      "addBox": "Add box",
      "yourPersonalDiscountApplied": "Your personal discount is applied",
      "generalDiscountApplied": "General discount is applied",
      "yourPersonalDiscount": "Your personal discount",
      "yourPersonalDiscountUnit": "Your personal discount unit",
      "generalDiscount": "General discount",
      "orderInfo": "Order info",
      "backToOrders": "Back to orders",
      "contact": "Contact",
      "productsInOrder": "Products in order",
      "waitsForConfirmation": "Waits for confirmation",
      "language": "en",
      "item": "Item",
      "statusHistory": "Status history",
      "orderPlacedSuccess": "Order successfully created and sent for review",
      "orderEditedByAdmin": "Order edited by administrator",
      "subTotal": "Subtotal",
      "order": "Order",
      "city": "City",
      "postalCode": "Postal code",
      "country": "Country",
      "firstName": "First name",
      "lastName": "Last name",
      "deliveryRules": "Delivery rules",
      "deliveryDays": "Delivery days",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "security": "Security",
      "noDescription": "No description available",
      "nutritionalValue": "Nutritional value",
      "back": "Back",
      "calories": "Calories",
      "protein": "Protein",
      "fat": "Fat",
      "carbohydrates": "Carbohydrates",
      "fiber": "Fiber",
      "servingSize": "Serving size",
      "caloriesUnit": "kcal",
      "g": "g",
      "completed": "Completed",
      "rejected": "Rejected",
      "repeatOrder": "Repeat order",
      "boxSales": "Box sales",
      "inBox": "In box",
      "boxPrice": "Box price",
      "boxQuantity": "Box quantity",
      "noOrders": "You have no orders yet",
      "inCart": "In cart",
      "loginError": "Login failed",
      "invalidCredentials": "Invalid credentials",
      "errorLoadingOrders": "Failed to load orders",
      // Catalog
      "productCatalog": "Product Catalog",
      "searchProducts": "Search products...",
      "sortByName": "By name",
      "sortByPriceAsc": "Price: ascending",
      "sortByPriceDesc": "Price: descending",
      "loadingProducts": "Loading products...",
      "noProductsFound": "No products found",
      "errorLoadingProducts": "Failed to load products",
      
      // Cart
      "yourCart": "Your Cart",
      "cartEmpty": "Your cart is empty",
      "addFromCatalog": "Add products from catalog",
      "goToCatalog": "Go to catalog",
      "clearCart": "Clear cart",
      "itemsInCart": "Items in cart:",
      "total": "Total:",
      "checkout": "Checkout",
      "remove": "Remove",
      "box": "Box",
      "pieces": "pcs",
      "minimumOrderWarning": "Minimum order amount: {{amount}}€",
      "addMoreProducts": "Add {{amount}}€ more",
      "priceDisclaimer": "Final price may vary depending on packaging.<br/>VAT is added to the total amount.",
      "orderHasNoItems": "Order contains no items",
      "addedToCart": "Added to cart",
      "items": "items",
      "unavailable": "Unavailable",
      "allItemsUnavailable": "Unfortunately, all items from the order are currently unavailable",
      "repeatOrderFailed": "Failed to repeat order",
      
      // Units
      "kg": "kg",
      "piece": "pc",
      "boxUnit": "box",
      "step": "step",
      "multiplicity": "Multiplicity",
      
      // Login
      "welcomeMessage": "Food delivery for restaurants",
      "loginTitle": "Login to system",
      "email": "Email",
      "password": "Password",
      "loginButton": "Login",
      "loggingIn": "Logging in...",
      "testCredentials": "Test credentials:",
      "admin": "Administrator",
      "client": "Client",
      
      // Footer
      "privacyPolicy": "Privacy Policy",
      "allRightsReserved": "All rights reserved",
      
      // Common
      "loading": "Loading...",
      "error": "Error",
      "success": "Success",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "search": "Search",
      "filter": "Filter",
      "sort": "Sort",
      "price": "Price",
      "quantity": "Quantity",
      "description": "Description",
      "category": "Category",
      "status": "Status",
      "actions": "Actions",
      "confirm": "Confirm",
      "close": "Close",
      
      // Product Details
      "productDetails": "Product Details",
      "addToCart": "Add to cart",
      "inStock": "In stock",
      "outOfStock": "Out of stock",
      "selectUnit": "Select unit",
      "perPiece": "Piece",
      "perBox": "Box",
      "discount": "Discount",
      "originalPrice": "Original price",
      "finalPrice": "Final price",
      
      // Orders
      "myOrders": "My Orders",
      "orderNumber": "Order No.",
      "orderDate": "Order date",
      "orderStatus": "Status",
      "orderTotal": "Total",
      "viewDetails": "View details",
      "orderDetails": "Order Details",
      "deliveryAddress": "Delivery address",
      "deliveryDate": "Delivery date",
      "orderItems": "Order items",
      "itemsCount": "Items count",
      
      // Order Statuses
      "pending": "Pending",
      "confirmed": "Confirmed",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      
      // Checkout
      "checkoutTitle": "Checkout",
      "deliveryInfo": "Delivery Information",
      "deliveryDateLabel": "Delivery date",
      "deliveryAddressLabel": "Delivery address",
      "notes": "Notes",
      "orderSummary": "Order Summary",
      "subtotal": "Subtotal",
      "deliveryFee": "Delivery",
      "placeOrder": "Place order",
      "yourOrder": "Your order",
      "deliveryDetails": "Delivery details",
      "additionalInfo": "Additional information",
      "orderComments": "Order comments...",
      "selectDate": "Select date",
      "submitting": "Submitting...",
      "submitOrder": "Submit order",
      
      // Profile
      "myProfile": "My Profile",
      "restaurantName": "Restaurant name",
      "contactPerson": "Contact person",
      "phone": "Phone",
      "address": "Address",
      "updateProfile": "Update profile",
      "changePassword": "Change password",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "street": "Street",
      // Admin Dashboard
      "adminDashboard": "Admin Dashboard",
      "statistics": "Statistics",
      "totalOrders": "Total orders",
      "totalRevenue": "Total revenue",
      "totalProducts": "Total products",
      "totalUsers": "Total users",
      "recentOrders": "Recent orders",
      "topProducts": "Top products",
      
      // Admin Products
      "manageProducts": "Manage Products",
      "addProduct": "Add product",
      "editProduct": "Edit product",
      "deleteProduct": "Delete product",
      "productName": "Product name",
      "productImage": "Product image",
      "productPrice": "Price",
      "productStock": "Stock",
      "productCategory": "Category",
      "productActive": "Active",
      "uploadImage": "Upload image",
      "searchProducts2": "Search products...",
      "importCategories": "Import categories",
      "importProducts": "Import products",
      "image": "Image",
      "name": "Name",
      "sortByDiscount": "Sort by discount",
      "sortByPopularity": "Sort by popularity",
      "sortByStock": "Sort by stock",
      "popularity": "Popularity",
      "stock": "Stock",
      "unit": "Unit",
      "allCategories": "All categories",
      
      // Admin Orders
      "manageOrders": "Manage Orders",
      "updateStatus": "Update status",
      "orderHistory": "Order history",
      "customer": "Customer",
      "paymentStatus": "Payment status",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "searchOrders": "Search by number or customer...",
      "orderNumber2": "Number",
      "createdDate": "Created date",
      "delivery": "Delivery",
      "itemsCount2": "Items",
      "amount": "Amount",
      "viewDetails2": "View details",
      "changeStatus": "Change status",
      "changeOrderStatus": "Change order status #",
      "currentStatus": "Current status",
      "newStatus": "New status",
      "commentOptional": "Comment (optional)",
      "allOrders": "All orders",
      "pendingOrders": "Pending confirmation",
      "confirmedOrders": "Confirmed",
      "processingOrders": "Processing",
      "completedOrders": "Completed",
      "cancelledOrders": "Cancelled",
      "rejectedOrders": "Rejected",
      
      // Admin Users
      "manageUsers": "Manage Clients",
      "addUser": "Add client",
      "editUser": "Edit client",
      "deleteUser": "Delete client",
      "userName": "Name",
      "userEmail": "Email",
      "userRole": "Role",
      "userStatus": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "personalDiscount": "Personal discount",
      
      // Validation Messages
      "fieldRequired": "This field is required",
      "invalidEmail": "Invalid email address",
      "passwordTooShort": "Password must be at least 6 characters",
      "passwordsNotMatch": "Passwords don't match",
      "invalidPrice": "Invalid price",
      "invalidQuantity": "Invalid quantity",
      
      // Success Messages
      "productAdded": "Product added to cart",
      "orderPlaced": "Order placed",
      "profileUpdated": "Profile updated",
      "passwordChanged": "Password changed",
      "productCreated": "Product created",
      "productUpdated": "Product updated",
      "productDeleted": "Product deleted",
      
      // Error Messages
      "generalError": "Something went wrong",
      "networkError": "Network error",
      "unauthorized": "Unauthorized access",
      "notFound": "Not found",
      "serverError": "Server error"
    }
  },
  ru: {
    translation: {
      // Header
      "catalog": "Каталог",
      "categories": "Категории",
      "allProducts": "Все продукты",
      "orders": "Заказы",
      "dashboard": "Панель управления",
      "products": "Продукты",
      "clients": "Клиенты",
      "cart": "Корзина",
      "profile": "Профиль",
      "logout": "Выход",
      "login": "Вход",
      "basicInfo": "Основная информация",
      "addBox": "Добавить ящик",
      "generalDiscountApplied": "Общая скидка применена",
      "generalDiscount": "Общая скидка",
      "orderInfo": "Информация о заказе",
      "backToOrders": "Вернуться к заказам", 
      "contact": "Контакт",
      "language": "ru",
      "statusHistory": "История статусов",
      "subTotal": "Промежуточный итог",
      "order": "Заказ",
      "city": "Город",
      "country": "Страна",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "deliveryRules": "Правила доставки",
      "deliveryDays": "Дни доставки",
      "monday": "Понедельник",
      "tuesday": "Вторник",
      "wednesday": "Среда",
      "thursday": "Четверг",
      "friday": "Пятница",
      "saturday": "Суббота",
      "sunday": "Воскресенье",
      "security": "Безопасность",
      "noDescription": "Описание не доступно",
      "nutritionalValue": "Пищевая ценность",
      "back": "Назад",
      "calories": "Калории",
      "protein": "Белки",
      "fat": "Жиры",
      "carbohydrates": "Углеводы",
      "fiber": "Клетчатка",
      "servingSize": "Размер порции",
      "caloriesUnit": "ккал",
      "g": "г",
      "completed": "Выполнен",
      "rejected": "Отклонен",
      "repeatOrder": "Повторить заказ",
      "boxSales": "Продажа ящиков",
      "inBox": "В ящике",
      "boxPrice": "Цена ящика",
      "boxQuantity": "Количество ящиков",
      "noOrders": "У вас пока нет заказов",
      "inCart": "В корзине",
      "loginError": "Вход не выполнен",
      "invalidCredentials": "Неверные учетные данные",
      "errorLoadingOrders": "Не удалось загрузить заказы",
      // Catalog
      "productCatalog": "Каталог продуктов",
      "searchProducts": "Поиск продуктов...",
      "sortByName": "По названию",
      "sortByPriceAsc": "Цена: по возрастанию",
      "sortByPriceDesc": "Цена: по убыванию",
      "loadingProducts": "Загрузка продуктов...",
      "noProductsFound": "Продукты не найдены",
      "errorLoadingProducts": "Не удалось загрузить продукты",
      "yourPersonalDiscountApplied": "Ваша персональная скидка применена",
      "yourPersonalDiscount": "Ваша персональная скидка",
      "yourPersonalDiscountUnit": "Ваша персональная скидка на единицу",
      "productsInOrder": "Товары в заказе",
      "item": "Товар",
      "orderPlacedSuccess": "Заказ успешно создан и отправлен на рассмотрение",
      "orderEditedByAdmin": "Заказ отредактирован администратором",
      "postalCode": "Почтовый индекс",
      // Cart
      "yourCart": "Ваша корзина",
      "cartEmpty": "Ваша корзина пуста",
      "addFromCatalog": "Добавьте товары из каталога",
      "goToCatalog": "Перейти в каталог",
      "clearCart": "Очистить корзину",
      "itemsInCart": "Товаров в корзине:",
      "total": "Итого:",
      "checkout": "Оформить заказ",
      "remove": "Удалить",
      "box": "Ящик",
      "pieces": "шт",
      "minimumOrderWarning": "Минимальная сумма заказа: {{amount}}€",
      "addMoreProducts": "Добавьте еще на {{amount}}€",
      "priceDisclaimer": "Конечная цена может отличаться в зависимости от комплектации.<br/>К сумме также добавляется НДС.",
      "orderHasNoItems": "Заказ не содержит товаров",
      "addedToCart": "Добавлено в корзину",
      "items": "позиций",
      "unavailable": "Недоступно",
      "allItemsUnavailable": "К сожалению, все товары из заказа сейчас недоступны",
      "repeatOrderFailed": "Не удалось повторить заказ",
      
      // Units
      "kg": "кг",
      "piece": "шт",
      "boxUnit": "ящ",
      "step": "шаг",
      "multiplicity": "Кратность",
      
      // Login
      "welcomeMessage": "Доставка продуктов для ресторанов",
      "loginTitle": "Вход в систему",
      "email": "Email",
      "password": "Пароль",
      "loginButton": "Войти",
      "loggingIn": "Вход...",
      "testCredentials": "Тестовые учетные данные:",
      "admin": "Администратор",
      "client": "Клиент",
      
      // Footer
      "privacyPolicy": "Политика конфиденциальности",
      "allRightsReserved": "Все права защищены",
      
      // Common
      "loading": "Загрузка...",
      "error": "Ошибка",
      "success": "Успешно",
      "save": "Сохранить",
      "cancel": "Отмена",
      "delete": "Удалить",
      "edit": "Изменить",
      "add": "Добавить",
      "search": "Поиск",
      "filter": "Фильтр",
      "sort": "Сортировка",
      "price": "Цена",
      "quantity": "Количество",
      "description": "Описание",
      "category": "Категория",
      "status": "Статус",
      "actions": "Действия",
      "confirm": "Подтвердить",
      "close": "Закрыть",
      
      // Product Details
      "productDetails": "Детали продукта",
      "addToCart": "Добавить в корзину",
      "inStock": "В наличии",
      "outOfStock": "Нет в наличии",
      "selectUnit": "Выберите единицу",
      "perPiece": "Штука",
      "perBox": "Ящик",
      "discount": "Скидка",
      "originalPrice": "Исходная цена",
      "finalPrice": "Итоговая цена",
      "waitsForConfirmation": "Ожидает подтверждения",
      
      // Orders
      "myOrders": "Мои заказы",
      "orderNumber": "Заказ №",
      "orderDate": "Дата заказа",
      "orderStatus": "Статус",
      "orderTotal": "Сумма",
      "viewDetails": "Посмотреть детали",
      "orderDetails": "Детали заказа",
      "deliveryAddress": "Адрес доставки",
      "deliveryDate": "Дата доставки",
      "orderItems": "Товары заказа",
      "itemsCount": "Количество товаров",
      
      // Order Statuses
      "pending": "Ожидает",
      "confirmed": "Подтверждён",
      "processing": "В обработке",
      "shipped": "Отправлен",
      "delivered": "Доставлен",
      "cancelled": "Отменён",
      "statusChanged": "Статус изменен",
      
      // Checkout
      "checkoutTitle": "Оформление заказа",
      "deliveryInfo": "Информация о доставке",
      "deliveryDateLabel": "Дата доставки",
      "deliveryAddressLabel": "Адрес доставки",
      "notes": "Примечания",
      "orderSummary": "Итоги заказа",
      "subtotal": "Промежуточный итог",
      "deliveryFee": "Доставка",
      "placeOrder": "Разместить заказ",
      "yourOrder": "Ваш заказ",
      "deliveryDetails": "Детали доставки",
      "additionalInfo": "Дополнительная информация",
      "orderComments": "Комментарии к заказу...",
      "selectDate": "Выберите дату",
      "submitting": "Отправка...",
      "submitOrder": "Отправить заказ",
      
      // Profile
      "myProfile": "Мой профиль",
      "restaurantName": "Название ресторана",
      "contactPerson": "Контактное лицо",
      "phone": "Телефон",
      "address": "Адрес",
      "updateProfile": "Обновить профиль",
      "changePassword": "Изменить пароль",
      "currentPassword": "Текущий пароль",
      "newPassword": "Новый пароль",
      "confirmPassword": "Подтвердите пароль",
      "street": "Улица",
      
      // Admin Dashboard
      "adminDashboard": "Панель администратора",
      "statistics": "Статистика",
      "totalOrders": "Всего заказов",
      "totalRevenue": "Общий доход",
      "totalProducts": "Всего продуктов",
      "totalUsers": "Всего пользователей",
      "recentOrders": "Последние заказы",
      "topProducts": "Популярные продукты",
      
      // Admin Products
      "manageProducts": "Управление продуктами",
      "addProduct": "Добавить продукт",
      "editProduct": "Изменить продукт",
      "deleteProduct": "Удалить продукт",
      "productName": "Название продукта",
      "productImage": "Изображение продукта",
      "productPrice": "Цена",
      "productStock": "Запас",
      "productCategory": "Категория",
      "productActive": "Активен",
      "uploadImage": "Загрузить изображение",
      "searchProducts2": "Поиск продуктов...",
      "importCategories": "Импорт категорий",
      "importProducts": "Импорт продуктов",
      "image": "Изображение",
      "name": "Название",
      "sortByDiscount": "Сортировать по скидке",
      "sortByPopularity": "Сортировать по популярности",
      "sortByStock": "Сортировать по остаткам",
      "popularity": "Популярность",
      "stock": "Склад",
      "unit": "Ед. изм.",
      "allCategories": "Все категории",
      
      // Admin Orders
      "manageOrders": "Управление заказами",
      "updateStatus": "Обновить статус",
      "orderHistory": "История заказов",
      "customer": "Клиент",
      "paymentStatus": "Статус оплаты",
      "paid": "Оплачено",
      "unpaid": "Не оплачено",
      "searchOrders": "Поиск по номеру или клиенту...",
      "orderNumber2": "Номер",
      "createdDate": "Дата создания",
      "delivery": "Доставка",
      "itemsCount2": "Товаров",
      "amount": "Сумма",
      "viewDetails2": "Подробнее",
      "changeStatus": "Изменить статус",
      "changeOrderStatus": "Изменить статус заказа #",
      "currentStatus": "Текущий статус",
      "newStatus": "Новый статус",
      "commentOptional": "Комментарий (опционально)",
      "allOrders": "Все заказы",
      "pendingOrders": "Ожидают подтверждения",
      "confirmedOrders": "Подтвержденные",
      "processingOrders": "В обработке",
      "completedOrders": "Выполненные",
      "cancelledOrders": "Отмененные",
      "rejectedOrders": "Отклоненные",
      
      // Admin Users
      "manageUsers": "Управление клиентами",
      "addUser": "Добавить клиента",
      "editUser": "Изменить клиента",
      "deleteUser": "Удалить клиента",
      "userName": "Имя",
      "userEmail": "Email",
      "userRole": "Роль",
      "userStatus": "Статус",
      "active": "Активен",
      "inactive": "Неактивен",
      "personalDiscount": "Персональная скидка",
      
      // Validation Messages
      "fieldRequired": "Это поле обязательно",
      "invalidEmail": "Неверный адрес электронной почты",
      "passwordTooShort": "Пароль должен содержать не менее 6 символов",
      "passwordsNotMatch": "Пароли не совпадают",
      "invalidPrice": "Неверная цена",
      "invalidQuantity": "Неверное количество",
      
      // Success Messages
      "productAdded": "Продукт добавлен в корзину",
      "orderPlaced": "Заказ размещён",
      "profileUpdated": "Профиль обновлён",
      "passwordChanged": "Пароль изменён",
      "productCreated": "Продукт создан",
      "productUpdated": "Продукт обновлён",
      "productDeleted": "Продукт удалён",
      
      // Error Messages
      "generalError": "Что-то пошло не так",
      "networkError": "Ошибка сети",
      "unauthorized": "Несанкционированный доступ",
      "notFound": "Не найдено",
      "serverError": "Ошибка сервера"
    }
  },
  it: {
    translation: {
      // Header
      "catalog": "Catalogo",
      "categories": "Categorie",
      "allProducts": "Tutti i prodotti",
      "orders": "Ordini",
      "dashboard": "Dashboard",
      "products": "Prodotti",
      "clients": "Clienti",
      "cart": "Carrello",
      "profile": "Profilo",
      "logout": "Esci",
      "login": "Accedi",
      "basicInfo": "Informazioni di base",
      "addBox": "Aggiungi scatola",
      "yourPersonalDiscountApplied": "Il tuo sconto personale è stato applicato",
      "generalDiscountApplied": "Lo sconto generale è stato applicato",
      "yourPersonalDiscount": "Il tuo sconto personale",
      "yourPersonalDiscountUnit": "Il tuo sconto personale per unità",
      "generalDiscount": "Sconto generale",
      "orderInfo": "Informazioni sull'ordine",
      "backToOrders": "Torna agli ordini",
      "contact": "Contatto",
      "productsInOrder": "Prodotti ordinati",
      "waitsForConfirmation": "In attesa di conferma",
      "language": "it",
      "item": "Prodotto",
      "statusHistory": "Cronologia dello stato",
      "orderPlacedSuccess": "Ordine inviato con successo",
      "orderEditedByAdmin": "Ordine modificato dall'amministratore",
      "subTotal": "Subtotale",
      "order": "Ordine",
      "city": "Città",
      "postalCode": "Codice postale",
      "country": "Paese",
      "firstName": "Nome",
      "lastName": "Cognome",
      "deliveryRules": "Tempi di consegna",
      "deliveryDays": "Tempi di consegna",
      "monday": "Lunedì",
      "tuesday": "Martedì",
      "wednesday": "Mercoledì",
      "thursday": "Giovedì",
      "friday": "Venerdì",
      "saturday": "Sabato",
      "sunday": "Domenica",
      "security": "Sicurezza",
      "noDescription": "Nessuna descrizione",
      "nutritionalValue": "Valore nutrizionale",
      "back": "Indietro",
      "calories": "Calorie",
      "protein": "Proteine",
      "fat": "Grassi",
      "carbohydrates": "Carboidrati",
      "fiber": "Fibre",
      "servingSize": "Dimensione della porzione",
      "caloriesUnit": "kcal",
      "g": "g",
      "completed": "Completato",
      "rejected": "Rifiutato",
      "repeatOrder": "Ripeti ordine",
      "boxSales": "Vendita scatole",
      "inBox": "In scatola",
      "boxPrice": "Prezzo scatola",
      "boxQuantity": "Quantità scatole",
      "noOrders": "Non hai ancora ordini",
      "inCart": "In carrello",
      "loginError": "Accesso non riuscito",
      "invalidCredentials": "Credenziali non valide",
      "errorLoadingOrders": "Errore nel caricamento degli ordini",
      // Catalog
      "productCatalog": "Catalogo prodotti",
      "searchProducts": "Cerca prodotti...",
      "sortByName": "Per nome",
      "sortByPriceAsc": "Prezzo: crescente",
      "sortByPriceDesc": "Prezzo: decrescente",
      "loadingProducts": "Caricamento prodotti...",
      "noProductsFound": "Nessun prodotto trovato",
      "errorLoadingProducts": "Errore nel caricamento dei prodotti",
      
      // Cart
      "yourCart": "Il tuo carrello",
      "cartEmpty": "Il tuo carrello è vuoto",
      "addFromCatalog": "Aggiungi prodotti dal catalogo",
      "goToCatalog": "Vai al catalogo",
      "clearCart": "Svuota carrello",
      "itemsInCart": "Prodotti nel carrello:",
      "total": "Totale:",
      "checkout": "Procedi all'ordine",
      "remove": "Rimuovi",
      "box": "Scatola",
      "pieces": "pz",
      "minimumOrderWarning": "Importo minimo ordine: {{amount}}€",
      "addMoreProducts": "Aggiungi ancora {{amount}}€",
      "priceDisclaimer": "Il prezzo finale può variare a seconda dell'imballaggio.<br/>All’importo viene aggiunta l’IVA.",
      "orderHasNoItems": "L'ordine non contiene prodotti",
      "addedToCart": "Aggiunto al carrello",
      "items": "articoli",
      "unavailable": "Non disponibile",
      "allItemsUnavailable": "Purtroppo tutti i prodotti dell'ordine non sono attualmente disponibili",
      "repeatOrderFailed": "Impossibile ripetere l'ordine",
      
      // Units
      "kg": "kg",
      "piece": "pz",
      "boxUnit": "scatola",
      "step": "passo",
      "multiplicity": "Molteplicità",
      
      // Login
      "welcomeMessage": "Trasporto alimentare per ristoranti",
      "loginTitle": "Accedi al sistema",
      "email": "E-mail",
      "password": "Password",
      "loginButton": "Accedi",
      "loggingIn": "Accesso in corso...",
      "testCredentials": "Credenziali di test:",
      "admin": "Amministratore",
      "client": "Cliente",
      
      // Footer
      "privacyPolicy": "Informativa sulla privacy",
      "allRightsReserved": "Tutti i diritti riservati",
      
      // Common
      "loading": "Caricamento...",
      "error": "Errore",
      "success": "Successo",
      "save": "Salva",
      "cancel": "Annulla",
      "delete": "Elimina",
      "edit": "Modifica",
      "add": "Aggiungi",
      "search": "Cerca",
      "filter": "Filtra",
      "sort": "Ordina",
      "price": "Prezzo",
      "quantity": "Quantità",
      "description": "Descrizione",
      "category": "Categoria",
      "status": "Stato",
      "actions": "Azioni",
      "confirm": "Conferma",
      "close": "Chiudi",
      
      // Product Details
      "productDetails": "Dettagli del prodotto",
      "addToCart": "Aggiungi al carrello",
      "inStock": "In stock",
      "outOfStock": "Esaurito",
      "selectUnit": "Seleziona unità",
      "perPiece": "Pezzo",
      "perBox": "Scatola",
      "discount": "Sconto",
      "originalPrice": "Prezzo originale",
      "finalPrice": "Prezzo finale",
      
      // Orders
      "myOrders": "I miei ordini",
      "orderNumber": "Ordine n.",
      "orderDate": "Data dell'ordine",
      "orderStatus": "Stato",
      "orderTotal": "Importo",
      "viewDetails": "Visualizza dettagli",
      "orderDetails": "Dettagli dell'ordine",
      "deliveryAddress": "Indirizzo di consegna",
      "deliveryDate": "Data di consegna",
      "orderItems": "Prodotti ordinati",
      "itemsCount": "Numero di prodotti",
      
      // Order Statuses
      "pending": "In attesa",
      "confirmed": "Confermato",
      "processing": "In elaborazione",
      "shipped": "Spedito",
      "delivered": "Consegnato",
      "cancelled": "Annullato",
      
      // Checkout
      "checkoutTitle": "Completamento dell'ordine",
      "deliveryInfo": "Informazioni sulla consegna",
      "deliveryDateLabel": "Data di consegna",
      "deliveryAddressLabel": "Indirizzo di consegna",
      "notes": "Note",
      "orderSummary": "Riepilogo ordine",
      "subtotal": "Subtotale",
      "deliveryFee": "Consegna",
      "placeOrder": "Invia ordine",
      "yourOrder": "Il tuo ordine",
      "deliveryDetails": "Dettagli di consegna",
      "additionalInfo": "Informazioni aggiuntive",
      "orderComments": "Commenti sull'ordine...",
      "selectDate": "Seleziona data",
      "submitting": "Invio in corso...",
      "submitOrder": "Invia ordine",
      
      // Profile
      "myProfile": "Il mio profilo",
      "restaurantName": "Nome del ristorante",
      "contactPerson": "Persona di contatto",
      "phone": "Telefono",
      "address": "Indirizzo",
      "updateProfile": "Aggiorna profilo",
      "changePassword": "Cambia password",
      "currentPassword": "Password attuale",
      "newPassword": "Nuova password",
      "confirmPassword": "Conferma password",
      "street": "Via",
      
      // Admin Dashboard
      "adminDashboard": "Dashboard amministratore",
      "statistics": "Statistiche",
      "totalOrders": "Ordini totali",
      "totalRevenue": "Fatturato totale",
      "totalProducts": "Prodotti totali",
      "totalUsers": "Utenti totali",
      "recentOrders": "Ordini recenti",
      "topProducts": "Prodotti popolari",
      
      // Admin Products
      "manageProducts": "Gestisci prodotti",
      "addProduct": "Aggiungi prodotto",
      "editProduct": "Modifica prodotto",
      "deleteProduct": "Elimina prodotto",
      "productName": "Nome del prodotto",
      "productImage": "Immagine del prodotto",
      "productPrice": "Prezzo",
      "productStock": "Stock",
      "productCategory": "Categoria",
      "productActive": "Attivo",
      "uploadImage": "Carica immagine",
      "searchProducts2": "Cerca prodotti...",
      "importCategories": "Importa categorie",
      "importProducts": "Importa prodotti",
      "image": "Immagine",
      "name": "Nome",
      "sortByDiscount": "Ordina per sconto",
      "sortByPopularity": "Ordina per popolarità",
      "sortByStock": "Ordina per stock",
      "popularity": "Popolarità",
      "stock": "Stock",
      "unit": "Unità",
      "allCategories": "Tutte le categorie",
      
      // Admin Orders
      "manageOrders": "Gestisci ordini",
      "updateStatus": "Aggiorna stato",
      "orderHistory": "Cronologia ordini",
      "customer": "Cliente",
      "paymentStatus": "Stato pagamento",
      "paid": "Pagato",
      "unpaid": "Non pagato",
      "searchOrders": "Cerca per numero o cliente...",
      "orderNumber2": "Numero",
      "createdDate": "Data di creazione",
      "delivery": "Consegna",
      "itemsCount2": "Articoli",
      "amount": "Importo",
      "viewDetails2": "Visualizza dettagli",
      "changeStatus": "Cambia stato",
      "changeOrderStatus": "Cambia stato ordine #",
      "currentStatus": "Stato attuale",
      "newStatus": "Nuovo stato",
      "commentOptional": "Commento (opzionale)",
      "allOrders": "Tutti gli ordini",
      "pendingOrders": "In attesa di conferma",
      "confirmedOrders": "Confermati",
      "processingOrders": "In elaborazione",
      "completedOrders": "Completati",
      "cancelledOrders": "Annullati",
      "rejectedOrders": "Rifiutati",
      
      // Admin Users
      "manageUsers": "Gestisci clienti",
      "addUser": "Aggiungi cliente",
      "editUser": "Modifica cliente",
      "deleteUser": "Elimina cliente",
      "userName": "Nome",
      "userEmail": "E-mail",
      "userRole": "Ruolo",
      "userStatus": "Stato",
      "active": "Attivo",
      "inactive": "Inattivo",
      "personalDiscount": "Sconto personale",
      
      // Validation Messages
      "fieldRequired": "Questo campo è obbligatorio",
      "invalidEmail": "Indirizzo e-mail non valido",
      "passwordTooShort": "La password deve essere almeno di 6 caratteri",
      "passwordsNotMatch": "Le password non corrispondono",
      "invalidPrice": "Prezzo non valido",
      "invalidQuantity": "Quantità non valida",
      
      // Success Messages
      "productAdded": "Prodotto aggiunto al carrello",
      "orderPlaced": "Ordine inviato",
      "profileUpdated": "Profilo aggiornato",
      "passwordChanged": "Password modificata",
      "productCreated": "Prodotto creato",
      "productUpdated": "Prodotto aggiornato",
      "productDeleted": "Prodotto eliminato",
      
      // Error Messages
      "generalError": "Qualcosa è andato storto",
      "networkError": "Errore di rete",
      "unauthorized": "Accesso non autorizzato",
      "notFound": "Non trovato",
      "serverError": "Errore del server"
    }
  },

  az: {
    translation: {
      // Header
      "catalog": "Kataloq",
      "categories": "Kateqoriyalar",
      "allProducts": "Bütün məhsullar",
      "orders": "Sifarişlər",
      "dashboard": "İdarə paneli",
      "products": "Məhsullar",
      "clients": "Müştərilər",
      "cart": "Səbət",
      "profile": "Profil",
      "logout": "Çıxış",
      "login": "Giriş",
      "basicInfo": "Əsas məlumatlar",
      "addBox": "Qutu əlavə et",
      "yourPersonalDiscountApplied": "Sizin isiklik allahindlusunuz tətbiq edilib",
      "generalDiscountApplied": "Üldine allahindlus tətbiq edilib",
      "yourPersonalDiscount": "Sizin isiklik allahindlusunuz",
      "yourPersonalDiscountUnit": "Sizin isiklik allahindlusunuz ühiklə",
      "generalDiscount": "General discount",
      "orderInfo": "Sifariş məlumatları",
      "backToOrders": "Sifarişlərə qayıt",
      "contact": "Əlaqə",
      "productsInOrder": "Sifariş məhsulları",
      "waitsForConfirmation": "Kinnitməyə gözləyir",
      "language": "az",
      "item": "Məhsul",
      "statusHistory": "Status history",
      "orderPlacedSuccess": "Sifariş uğurla yaradıldı və təsdiq gözləyir",
      "orderEditedByAdmin": "Sifariş administrator tərəfindən redaktə edilib",
      "subTotal": "Ara cəm",
      "order": "Sifariş",
      "street": "Sosial şəhər",
      "city": "Şəhər",
      "postalCode": "Poçt indeksi",
      "country": "Ölkə",
      "firstName": "Ad",
      "lastName": "Soyad",
      "deliveryRules": "Təqdimat qaydaları",
      "deliveryDays": "Təqdimat günləri",
      "monday": "Bazar ertəsi",
      "tuesday": "Çərşənbə axşamı",
      "wednesday": "Çərşənbə",
      "thursday": "Cümə axşamı",
      "friday": "Cümə",
      "saturday": "Şənbə",
      "sunday": "Bazar",
      "security": "Təhlükəsizlik",
      "noDescription": "Təsvir yoxdur",
      "nutritionalValue": "Təbii dəyər",
      "back": "Geri",
      "calories": "Kalori",
      "protein": "Zülal",
      "fat": "Yağ",
      "carbohydrates": "Karbohidratlar",
      "fiber": "Lif",
      "servingSize": "Porsiya ölçüsü",
      "caloriesUnit": "kcal",
      "g": "g",
      "completed": "Tamamlandı",
      "rejected": "Rədd edildi",
      "repeatOrder": "Sifarişi təkrarla",
      "boxSales": "Kastide müük",
      "inBox": "Kastis",
      "boxPrice": "Kasti hind",
      "boxQuantity": "Kasti kogus",
      "noOrders": "Sizin hələlik sifarişiniz yoxdur",
      "inCart": "Səbətdə",
      "loginError": "Giriş uğursuz oldu",
      "invalidCredentials": "Geçersiz kullanıcı adı veya şifre",
      "errorLoadingOrders": "Sifarişlərin yüklənməsi uğursuz oldu",
      // Catalog
      "productCatalog": "Məhsul kataloqu",
      "searchProducts": "Məhsul axtarın...",
      "sortByName": "Ada görə",
      "sortByPriceAsc": "Qiymət: artan",
      "sortByPriceDesc": "Qiymət: azalan",
      "loadingProducts": "Məhsullar yüklənir...",
      "noProductsFound": "Məhsul tapılmadı",
      "errorLoadingProducts": "Məhsulları yükləmək mümkün olmadı",
      
      // Cart
      "yourCart": "Sizin səbətiniz",
      "cartEmpty": "Səbətiniz boşdur",
      "addFromCatalog": "Kataloqdan məhsul əlavə edin",
      "goToCatalog": "Kataloqa keçin",
      "clearCart": "Səbəti təmizlə",
      "itemsInCart": "Səbətdə məhsullar:",
      "total": "Cəmi:",
      "checkout": "Sifarişi rəsmiləşdir",
      "remove": "Sil",
      "box": "Qutu",
      "pieces": "ədəd",
      "minimumOrderWarning": "Minimum sifariş məbləği: {{amount}}€",
      "addMoreProducts": "Daha {{amount}}€ məhsul əlavə edin",
      "priceDisclaimer": "Son qiymət qablaşdırmadan asılı olaraq dəyişə bilər.<br/>Məbləğə ƏDV əlavə olunur.",
      "orderHasNoItems": "Sifariş məhsul ehtiva etmir",
      "addedToCart": "Səbətə əlavə edildi",
      "items": "məhsul",
      "unavailable": "Mövcud deyil",
      "allItemsUnavailable": "Təəssüf ki, sifarişdəki bütün məhsullar hal-hazırda əlçatan deyil",
      "repeatOrderFailed": "Sifarişi təkrarlamaq mümkün olmadı",
      
      // Units
      "kg": "kq",
      "piece": "ədəd",
      "boxUnit": "qutu",
      "step": "addım",
      "multiplicity": "Çoxluq",
      
      // Login
      "welcomeMessage": "Restoranlar üçün yemək çatdırılması",
      "loginTitle": "Sistemə giriş",
      "email": "E-poçt",
      "password": "Şifrə",
      "loginButton": "Daxil ol",
      "loggingIn": "Giriş...",
      "testCredentials": "Test məlumatları:",
      "admin": "Administrator",
      "client": "Müştəri",
      
      // Footer
      "privacyPolicy": "Məxfilik siyasəti",
      "allRightsReserved": "Bütün hüquqlar qorunur",
      
      // Common
      "loading": "Yüklənir...",
      "error": "Xəta",
      "success": "Uğurlu",
      "save": "Saxla",
      "cancel": "Ləğv et",
      "delete": "Sil",
      "edit": "Redaktə et",
      "add": "Əlavə et",
      "search": "Axtar",
      "filter": "Filtr",
      "sort": "Çeşidlə",
      "price": "Qiymət",
      "quantity": "Miqdar",
      "description": "Təsvir",
      "category": "Kateqoriya",
      "status": "Status",
      "actions": "Əməliyyatlar",
      "confirm": "Təsdiq et",
      "close": "Bağla",
      
      // Product Details
      "productDetails": "Məhsul təfərrüatları",
      "addToCart": "Səbətə əlavə et",
      "inStock": "Stokda",
      "outOfStock": "Stokda yoxdur",
      "selectUnit": "Vahid seçin",
      "perPiece": "Ədəd",
      "perBox": "Qutu",
      "discount": "Endirim",
      "originalPrice": "Orijinal qiymət",
      "finalPrice": "Son qiymət",
      
      // Orders
      "myOrders": "Mənim sifarişlərim",
      "orderNumber": "Sifariş №",
      "orderDate": "Sifariş tarixi",
      "orderStatus": "Status",
      "orderTotal": "Məbləğ",
      "viewDetails": "Təfərrüatlara bax",
      "orderDetails": "Sifariş təfərrüatları",
      "deliveryAddress": "Çatdırılma ünvanı",
      "deliveryDate": "Çatdırılma tarixi",
      "orderItems": "Sifariş məhsulları",
      "itemsCount": "Məhsul sayı",
      
      // Order Statuses
      "pending": "Gözləyir",
      "confirmed": "Təsdiqləndi",
      "processing": "İşlənir",
      "shipped": "Göndərildi",
      "delivered": "Çatdırıldı",
      "cancelled": "Ləğv edildi",
      
      // Checkout
      "checkoutTitle": "Sifarişin rəsmiləşdirilməsi",
      "deliveryInfo": "Çatdırılma məlumatı",
      "deliveryDateLabel": "Çatdırılma tarixi",
      "deliveryAddressLabel": "Çatdırılma ünvanı",
      "notes": "Qeydlər",
      "orderSummary": "Sifariş xülasəsi",
      "subtotal": "Ara cəm",
      "deliveryFee": "Çatdırılma",
      "placeOrder": "Sifarişi yerləşdir",
      "yourOrder": "Sizin sifarişiniz",
      "deliveryDetails": "Çatdırılma təfərrüatları",
      "additionalInfo": "Əlavə məlumat",
      "orderComments": "Sifariş şərhləri...",
      "selectDate": "Tarix seçin",
      "submitting": "Göndərilir...",
      "submitOrder": "Sifarişi göndər",
      
      // Profile
      "myProfile": "Mənim profilim",
      "restaurantName": "Restoranın adı",
      "contactPerson": "Əlaqə şəxsi",
      "phone": "Telefon",
      "address": "Ünvan",
      "updateProfile": "Profili yenilə",
      "changePassword": "Şifrəni dəyişdir",
      "currentPassword": "Cari şifrə",
      "newPassword": "Yeni şifrə",
      "confirmPassword": "Şifrəni təsdiq edin",
      
      // Admin Dashboard
      "adminDashboard": "Administrator paneli",
      "statistics": "Statistika",
      "totalOrders": "Cəmi sifarişlər",
      "totalRevenue": "Ümumi gəlir",
      "totalProducts": "Cəmi məhsullar",
      "totalUsers": "Cəmi istifadəçilər",
      "recentOrders": "Son sifarişlər",
      "topProducts": "Populyar məhsullar",
      
      // Admin Products
      "manageProducts": "Məhsulları idarə et",
      "addProduct": "Məhsul əlavə et",
      "editProduct": "Məhsulu redaktə et",
      "deleteProduct": "Məhsulu sil",
      "productName": "Məhsulun adı",
      "productImage": "Məhsul şəkli",
      "productPrice": "Qiymət",
      "productStock": "Stok",
      "productCategory": "Kateqoriya",
      "productActive": "Aktiv",
      "uploadImage": "Şəkil yüklə",
      "searchProducts2": "Məhsul axtarın...",
      "importCategories": "Kateqoriyaları idxal et",
      "importProducts": "Məhsulları idxal et",
      "image": "Şəkil",
      "name": "Ad",
      "sortByDiscount": "Endirimlə çeşidlə",
      "sortByPopularity": "Populyarlığa görə",
      "sortByStock": "Stoka görə",
      "popularity": "Populyarlıq",
      "stock": "Stok",
      "unit": "Vahid",
      "allCategories": "Bütün kateqoriyalar",
      
      // Admin Orders
      "manageOrders": "Sifarişləri idarə et",
      "updateStatus": "Statusu yenilə",
      "orderHistory": "Sifariş tarixçəsi",
      "customer": "Müştəri",
      "paymentStatus": "Ödəniş statusu",
      "paid": "Ödənilib",
      "unpaid": "Ödənilməyib",
      "searchOrders": "Nömrə və ya müştəri ilə axtar...",
      "orderNumber2": "Nömrə",
      "createdDate": "Yaradılma tarixi",
      "delivery": "Çatdırılma",
      "itemsCount2": "Məhsullar",
      "amount": "Məbləğ",
      "viewDetails2": "Ətraflı bax",
      "changeStatus": "Statusu dəyişdir",
      "changeOrderStatus": "Sifariş statusunu dəyişdir #",
      "currentStatus": "Cari status",
      "newStatus": "Yeni status",
      "commentOptional": "Şərh (istəyə görə)",
      "allOrders": "Bütün sifarişlər",
      "pendingOrders": "Təsdiq gözləyir",
      "confirmedOrders": "Təsdiqləndi",
      "processingOrders": "İşlənir",
      "completedOrders": "Tamamlandı",
      "cancelledOrders": "Ləğv edildi",
      "rejectedOrders": "Rədd edildi",
      
      // Admin Users
      "manageUsers": "Müştəriləri idarə et",
      "addUser": "Müştəri əlavə et",
      "editUser": "Müştərini redaktə et",
      "deleteUser": "Müştərini sil",
      "userName": "Ad",
      "userEmail": "E-poçt",
      "userRole": "Rol",
      "userStatus": "Status",
      "active": "Aktiv",
      "inactive": "Qeyri-aktiv",
      "personalDiscount": "Şəxsi endirim",
      
      // Validation Messages
      "fieldRequired": "Bu sahə mütləqdir",
      "invalidEmail": "Yanlış e-poçt ünvanı",
      "passwordTooShort": "Şifrə ən azı 6 simvol olmalıdır",
      "passwordsNotMatch": "Şifrələr uyğun gəlmir",
      "invalidPrice": "Yanlış qiymət",
      "invalidQuantity": "Yanlış miqdar",
      
      // Success Messages
      "productAdded": "Məhsul səbətə əlavə edildi",
      "orderPlaced": "Sifariş yerləşdirildi",
      "profileUpdated": "Profil yeniləndi",
      "passwordChanged": "Şifrə dəyişdirildi",
      "productCreated": "Məhsul yaradıldı",
      "productUpdated": "Məhsul yeniləndi",
      "productDeleted": "Məhsul silindi",
      
      // Error Messages
      "generalError": "Nəsə səhv getdi",
      "networkError": "Şəbəkə xətası",
      "unauthorized": "İcazəsiz giriş",
      "notFound": "Tapılmadı",
      "serverError": "Server xətası"
    }
  },
  hy: {
    translation: {
      // Header
      "catalog": "Կատալոգ",
      "categories": "Կատեգորիաներ",
      "allProducts": "Բոլոր ապրանքները",
      "orders": "Պատվերներ",
      "dashboard": "Կառավարման վահանակ",
      "products": "Ապրանքներ",
      "clients": "Հաճախորդներ",
      "cart": "Զամբյուղ",
      "profile": "Պրոֆիլ",
      "logout": "Ելք",
      "login": "Մուտք",
      "basicInfo": "Անկախական տեղեկություններ",
      "addBox": "Տուփ ավելացնել",
      "yourPersonalDiscountApplied": "Ձեր սեփական զեղչը կիրառված է",
      "generalDiscountApplied": "Միջազգային զեղչը կիրառված է",
      "yourPersonalDiscount": "Ձեր սեփական զեղչը",
      "yourPersonalDiscountUnit": "Ձեր սեփական զեղչը միավորով",
      "generalDiscount": "Միջազգային զեղչը",
      "orderInfo": "Պատվերի տեղեկություններ",
      "backToOrders": "Պատվերներին վերադառնալ",
      "contact": "Հետագծում",
      "productsInOrder": "Պատվերի ապրանքներ",
      "waitsForConfirmation": "Սպասում է հաստատման",
      "language": "hy",
      "item": "Ապրանք",
      "statusHistory": "Պատվերի վիճակագրություն",
      "orderPlacedSuccess": "Պատվերը հաջողությամբ ստեղծվել է և սպասում է ստուգման",
      "orderEditedByAdmin": "Պատվերը խմբագրվել է ադմինիստրատորի կողմից",
      "subTotal": "Առանց զեղչի գումար",
      "order": "Պատվեր",
      "street": "Սովորական քաղաք",
      "city": "Քաղաք",
      "postalCode": "Փոստային ինդեքս",
      "country": "Երկիր",
      "firstName": "Անուն",
      "lastName": "Ազգանուն",
      "deliveryRules": "Առաքման կանոններ",
      "deliveryDays": "Առաքման օրեր",
      "monday": "Երկուշաբթի",
      "tuesday": "Երեքշաբթի",
      "wednesday": "Չորեքշաբթի",
      "thursday": "Հինգշաբթի",
      "friday": "Ուրբաթ",
      "saturday": "Շաբաթ",
      "sunday": "Կիրակի",
      "security": "Անվտանգություն",
      "noDescription": "Նկարագրություն չկա",
      "nutritionalValue": "Հարուստության արժեք",
      "back": "Հետ",
      "calories": "Քալորիա",
      "protein": "Բ پروտեին",
      "fat": "Ճարպեր",
      "carbohydrates": "Ածխաջրեր",
      "fiber": "Մանրաթելեր",
      "servingSize": "Մասի չափը",
      "caloriesUnit": "կկալ",
      "g": "գ",
      "completed": "Տեղափոխվել է",
      "rejected": "Հրաժարվել է",
      "repeatOrder": "Կրկնել պատվերը",
      "boxSales": "Կաթսայի վաճառք",
      "inBox": "Կաթսայում",
      "boxPrice": "Կաթսայի գին",
      "boxQuantity": "Կաթսայի քանակ",
      "noOrders": "Դուք չունեք պատվերներ",
      "inCart": "Զամբյուղում",
      "loginError": "Գրանցում ձախողվեց",
      "invalidCredentials": "Անվավեր հաշիվ կամ գաղտնաբառ",
      "errorLoadingOrders": "Sifarişlərin yüklənməsi uğursuz oldu",
      // Catalog
      "productCatalog": "Ապրանքների կատալոգ",
      "searchProducts": "Փնտրել ապրանքներ...",
      "sortByName": "Անունով",
      "sortByPriceAsc": "Գին՝ աճող",
      "sortByPriceDesc": "Գին՝ նվազող",
      "loadingProducts": "Ապրանքները բեռնվում են...",
      "noProductsFound": "Ապրանքներ չեն գտնվել",
      "errorLoadingProducts": "Ապրանքները բեռնելը չհաջողվեց",
      
      // Cart
      "yourCart": "Ձեր զամբյուղը",
      "cartEmpty": "Ձեր զամբյուղը դատարկ է",
      "addFromCatalog": "Ավելացրեք ապրանքներ կատալոգից",
      "goToCatalog": "Անցնել կատալոգ",
      "clearCart": "Մաքրել զամբյուղը",
      "itemsInCart": "Ապրանքներ զամբյուղում՝",
      "total": "Ընդամենը՝",
      "checkout": "Պատվիրել",
      "remove": "Հեռացնել",
      "box": "Տուփ",
      "pieces": "հատ",
      "minimumOrderWarning": "Նվազագույն պատվերի գումարը՝ {{amount}}€",
      "addMoreProducts": "Ավելացրեք ևս {{amount}}€",
      "priceDisclaimer": "Վերջնական գինը կարող է տարբերվել՝ կախված փաթեթավորումից.<br/>Գումարին ավելացվում է ԱԱՀ։",
      "orderHasNoItems": "Պատվերը չի պարունակում ապրանքներ",
      "addedToCart": "Ավելացվել է զամբյուղում",
      "items": "ապրանքներ",
      "unavailable": "Անհասանելի է",
      "allItemsUnavailable": "Ցավոք, պատվերի բոլոր ապրանքները ներկայումս անհասանելի են",
      "repeatOrderFailed": "Չհաջողվեց կրկնել պատվերը",
      
      // Units
      "kg": "կգ",
      "piece": "հատ",
      "boxUnit": "տուփ",
      
      // Login
      "welcomeMessage": "Սննդի առաքում ռեստորանների համար",
      "loginTitle": "Մուտք համակարգ",
      "email": "Էլ. փոստ",
      "password": "Գաղտնաբառ",
      "loginButton": "Մուտք",
      "loggingIn": "Մուտք...",
      "testCredentials": "Փորձարկման տվյալներ՝",
      "admin": "Ադմինիստրատոր",
      "client": "Հաճախորդ",
      
      // Footer
      "privacyPolicy": "Գաղտնիության քաղաքականություն",
      "allRightsReserved": "Բոլոր իրավունքները պաշտպանված են",
      
      // Common
      "loading": "Բեռնվում է...",
      "error": "Սխալ",
      "success": "Հաջողություն",
      "save": "Պահպանել",
      "cancel": "Չեղարկել",
      "delete": "Ջնջել",
      "edit": "Խմբագրել",
      "add": "Ավելացնել",
      "search": "Փնտրել",
      "filter": "Ֆիլտր",
      "sort": "Դասավորել",
      "price": "Գին",
      "quantity": "Քանակ",
      "description": "Նկարագրություն",
      "category": "Կատեգորիա",
      "status": "Կարգավիճակ",
      "actions": "Գործողություններ",
      "confirm": "Հաստատել",
      "close": "Փակել",
      
      // Product Details
      "productDetails": "Ապրանքի մանրամասներ",
      "addToCart": "Ավելացնել զամբյուղ",
      "inStock": "Առկա է",
      "outOfStock": "Չկա պահեստում",
      "selectUnit": "Ընտրել միավոր",
      "perPiece": "Հատ",
      "perBox": "Տուփ",
      "discount": "Զեղչ",
      "originalPrice": "Սկզբնական գին",
      "finalPrice": "Վերջնական գին",
      
      // Orders
      "myOrders": "Իմ պատվերները",
      "orderNumber": "Պատվեր №",
      "orderDate": "Պատվերի ամսաթիվ",
      "orderStatus": "Կարգավիճակ",
      "orderTotal": "Գումար",
      "viewDetails": "Դիտել մանրամասները",
      "orderDetails": "Պատվերի մանրամասներ",
      "deliveryAddress": "Առաքման հասցե",
      "deliveryDate": "Առաքման ամսաթիվ",
      "orderItems": "Պատվերի ապրանքներ",
      "itemsCount": "Ապրանքների քանակ",
      
      // Order Statuses
      "pending": "Սպասվող",
      "confirmed": "Հաստատված",
      "processing": "Մշակվում է",
      "shipped": "Ուղարկված",
      "delivered": "Առաքված",
      "cancelled": "Չեղարկված",
      
      // Checkout
      "checkoutTitle": "Պատվերի ձևակերպում",
      "deliveryInfo": "Առաքման տեղեկատվություն",
      "deliveryDateLabel": "Առաքման ամսաթիվ",
      "deliveryAddressLabel": "Առաքման հասցե",
      "notes": "Նշումներ",
      "orderSummary": "Պատվերի ամփոփում",
      "subtotal": "Միջանկյալ գումար",
      "deliveryFee": "Առաքում",
      "placeOrder": "Կատարել պատվեր",
      "yourOrder": "Ձեր պատվերը",
      "deliveryDetails": "Առաքման մանրամասներ",
      "additionalInfo": "Լրացուցիչ տեղեկություն",
      "orderComments": "Պատվերի մեկնաբանություններ...",
      "selectDate": "Ընտրեք ամսաթիվ",
      "submitting": "Ուղարկում...",
      "submitOrder": "Ուղարկել պատվերը",
      
      // Profile
      "myProfile": "Իմ պրոֆիլը",
      "restaurantName": "Ռեստորանի անունը",
      "contactPerson": "Կոնտակտային անձ",
      "phone": "Հեռախոս",
      "address": "Հասցե",
      "updateProfile": "Թարմացնել պրոֆիլը",
      "changePassword": "Փոխել գաղտնաբառը",
      "currentPassword": "Ընթացիկ գաղտնաբառ",
      "newPassword": "Նոր գաղտնաբառ",
      "confirmPassword": "Հաստատել գաղտնաբառը",
      
      // Admin Dashboard
      "adminDashboard": "Ադմինիստրատորի վահանակ",
      "statistics": "Վիճակագրություն",
      "totalOrders": "Ընդամենը պատվերներ",
      "totalRevenue": "Ընդհանուր եկամուտ",
      "totalProducts": "Ընդամենը ապրանքներ",
      "totalUsers": "Ընդամենը օգտատերեր",
      "recentOrders": "Վերջին պատվերները",
      "topProducts": "Հանրաճանաչ ապրանքներ",
      
      // Admin Products
      "manageProducts": "Կառավարել ապրանքները",
      "addProduct": "Ավելացնել ապրանք",
      "editProduct": "Խմբագրել ապրանքը",
      "deleteProduct": "Ջնջել ապրանքը",
      "productName": "Ապրանքի անունը",
      "productImage": "Ապրանքի նկարը",
      "productPrice": "Գին",
      "productStock": "Պահեստ",
      "productCategory": "Կատեգորիա",
      "productActive": "Ակտիվ",
      "uploadImage": "Վերբեռնել նկար",
      "searchProducts2": "Փնտրել ապրանքներ...",
      "importCategories": "Ներմուծել կատեգորիաներ",
      "importProducts": "Ներմուծել ապրանքներ",
      "image": "Նկար",
      "name": "Անուն",
      "sortByDiscount": "Դասավորել զեղչով",
      "sortByPopularity": "Հանրաճանաչության համաձայն",
      "sortByStock": "Պահեստի համաձայն",
      "popularity": "Հանրաճանաչություն",
      "stock": "Պահեստ",
      "unit": "Միավոր",
      "allCategories": "Բոլոր կատեգորիաները",
      
      // Admin Orders
      "manageOrders": "Կառավարել պատվերները",
      "updateStatus": "Թարմացնել կարգավիճակը",
      "orderHistory": "Պատվերների պատմություն",
      "customer": "Հաճախորդ",
      "paymentStatus": "Վճարման կարգավիճակ",
      "paid": "Վճարված",
      "unpaid": "Չվճարված",
      "searchOrders": "Փնտրել համարով կամ հաճախորդով...",
      "orderNumber2": "Համար",
      "createdDate": "Ստեղծման ամսաթիվ",
      "delivery": "Առաքում",
      "itemsCount2": "Ապրանքներ",
      "amount": "Գումար",
      "viewDetails2": "Մանրամասներ",
      "changeStatus": "Փոխել կարգավիճակը",
      "changeOrderStatus": "Փոխել պատվերի կարգավիճակը #",
      "currentStatus": "Ընթացիկ կարգավիճակ",
      "newStatus": "Նոր կարգավիճակ",
      "commentOptional": "Մեկնաբանություն (ըստ ցանկության)",
      "allOrders": "Բոլոր պատվերները",
      "pendingOrders": "Սպասվում է հաստատում",
      "confirmedOrders": "Հաստատված",
      "processingOrders": "Մշակվում է",
      "completedOrders": "Ավարտված",
      "cancelledOrders": "Չեղարկված",
      "rejectedOrders": "Մերժված",
      
      // Admin Users
      "manageUsers": "Կառավարել հաճախորդները",
      "addUser": "Ավելացնել հաճախորդ",
      "editUser": "Խմբագրել հաճախորդին",
      "deleteUser": "Ջնջել հաճախորդին",
      "userName": "Անուն",
      "userEmail": "Էլ. փոստ",
      "userRole": "Դեր",
      "userStatus": "Կարգավիճակ",
      "active": "Ակտիվ",
      "inactive": "Ոչ ակտիվ",
      "personalDiscount": "Անհատական զեղչ",
      
      // Validation Messages
      "fieldRequired": "Այս դաշտը պարտադիր է",
      "invalidEmail": "Անվավեր էլ. փոստի հասցե",
      "passwordTooShort": "Գաղտնաբառը պետք է լինի առնվազն 6 նիշ",
      "passwordsNotMatch": "Գաղտնաբառերը չեն համընկնում",
      "invalidPrice": "Անվավեր գին",
      "invalidQuantity": "Անվավեր քանակ",
      
      // Success Messages
      "productAdded": "Ապրանքը ավելացվել է զամբյուղում",
      "orderPlaced": "Պատվերը կատարվել է",
      "profileUpdated": "Պրոֆիլը թարմացվել է",
      "passwordChanged": "Գաղտնաբառը փոխվել է",
      "productCreated": "Ապրանքը ստեղծվել է",
      "productUpdated": "Ապրանքը թարմացվել է",
      "productDeleted": "Ապրանքը ջնջվել է",
      
      // Error Messages
      "generalError": "Ինչ-որ բան սխալ է եղել",
      "networkError": "Ցանցի սխալ",
      "unauthorized": "Չթույլատրված մուտք",
      "notFound": "Չի գտնվել",
      "serverError": "Սերվերի սխալ"
    }
  },
  ka: {
    translation: {
      // Header
      "catalog": "კატალოგი",
      "categories": "კატეგორიები",
      "allProducts": "ყველა პროდუქტი",
      "orders": "შეკვეთები",
      "dashboard": "მართვის პანელი",
      "products": "პროდუქტები",
      "clients": "კლიენტები",
      "cart": "კალათა",
      "profile": "პროფილი",
      "logout": "გასვლა",
      "login": "შესვლა",
      "basicInfo": "ძირითადი ინფორმაცია",
      "addBox": "ყუთის დამატება",
      "yourPersonalDiscountApplied": "თქვენი პერსონალური ფასდაკლება მოხდა",
      "generalDiscountApplied": "საერთაშორისო ფასდაკლება მოხდა",
      "yourPersonalDiscount": "თქვენი პერსონალური ფასდაკლება",
      "yourPersonalDiscountUnit": "თქვენი პერსონალური ფასდაკლება ერთეულზე",
      "generalDiscount": "საერთაშორისო ფასდაკლება",
      "orderInfo": "შეკვეთის ინფორმაცია",
      "backToOrders": "შეკვეთებზე დაბრუნება",
      "contact": "კონტაქტი",
      "productsInOrder": "შეკვეთის პროდუქტები",
      "waitsForConfirmation": "დადასტურების მოლოდინი",
      "language": "ka",
      "item": "პროდუქტი",
      "statusHistory": "Status history",
      "orderPlacedSuccess": "შეკვეთა წარმატებით შეიქმნა და მიმდინარეა დამუშავება",
      "orderEditedByAdmin": "შეკვეთა შეცვალა ადმინისტრატორმა",
      "subTotal": "საწყისი ჯამი",
      "order": "შეკვეთა",
      "street": "სოციალური სტრუქტურა",
      "city": "სტრუქტურა",
      "postalCode": "საფოსტო ინდექსი",
      "country": "სტრუქტურა",
      "firstName": "სახელი",
      "lastName": "გვარი",
      "deliveryRules": "მიწოდების წესები",
      "deliveryDays": "მიტანის დღეები",
      "monday": "ორშაბათი",
      "tuesday": "სამშაბათი",
      "wednesday": "ოთხშაბათი",
      "thursday": "ხუთშაბათი",
      "friday": "პარასკევი",
      "saturday": "შაბათი",
      "sunday": "კვირა",
      "security": "უსაფრთხოება",
      "noDescription": "აღწერა არაა",
      "nutritionalValue": "კვების ღირებულება",
      "back": "უკან",
      "calories": "კალორია",
      "protein": "პროტეინი",
      "fat": "ცხიმი",
      "carbohydrates": "ნახშირწყლები",
      "fiber": "ბოჭკო",
      "caloriesUnit": "კკალ",
      "g": "გ",
      "completed": "დასრულებული",
      "rejected": "უარყოფილი",
      "repeatOrder": "შეკვეთის გადატვირთვა",
      "boxSales": "ყუთის ვარჯისობა",
      "inBox": "ყუთში",
      "boxPrice": "ყუთის ფასი",
      "boxQuantity": "ყუთის რაოდენობა",
      "noOrders": "თქვენ ჯერ არ გაქვთ შეკვეთები",
      "inCart": "კალათაში",
      "loginError": "შესვლა ვერ მოხერხდა",
      "invalidCredentials": "შესვლის მონაცემები არასწორია",
      "errorLoadingOrders": "შეკვეთების ჩატვირთვა ვერ მოხერხდა",
      // Catalog
      "productCatalog": "პროდუქტების კატალოგი",
      "searchProducts": "პროდუქტების ძებნა...",
      "sortByName": "სახელით",
      "sortByPriceAsc": "ფასი: ზრდადი",
      "sortByPriceDesc": "ფასი: კლებადი",
      "loadingProducts": "პროდუქტები იტვირთება...",
      "noProductsFound": "პროდუქტები ვერ მოიძებნა",
      "errorLoadingProducts": "პროდუქტების ჩატვირთვა ვერ მოხერხდა",
      
      // Cart
      "yourCart": "თქვენი კალათა",
      "cartEmpty": "თქვენი კალათა ცარიელია",
      "addFromCatalog": "დაამატეთ პროდუქტები კატალოგიდან",
      "goToCatalog": "კატალოგში გადასვლა",
      "clearCart": "კალათის გასუფთავება",
      "itemsInCart": "პროდუქტები კალათაში:",
      "total": "სულ:",
      "checkout": "შეკვეთის გაფორმება",
      "remove": "წაშლა",
      "box": "ყუთი",
      "pieces": "ც",
      "minimumOrderWarning": "მინიმალური შეკვეთის თანხა: {{amount}}€",
      "addMoreProducts": "დაამატეთ კიდევ {{amount}}€",
      "priceDisclaimer": "საბოლოო ფასი შეიძლება განსხვავდებოდეს შეფუთვის მიხედვით.<br/>თანხას ემატება დღგ.",
      "orderHasNoItems": "შეკვეთა არ შეიცავს პროდუქტებს",
      "addedToCart": "დამატებულია კალათაში",
      "items": "პროდუქტი",
      "unavailable": "მიუწვდომელია",
      "allItemsUnavailable": "სამწუხაროდ, შეკვეთის ყველა პროდუქტი ამჟამად მიუწვდომელია",
      "repeatOrderFailed": "შეკვეთის გადატვირთვა ვერ მოხერხდა",
      
      // Units
      "kg": "კგ",
      "piece": "ც",
      "boxUnit": "ყუთი",
      
      // Login
      "welcomeMessage": "საკვების მიწოდება რესტორნებისთვის",
      "loginTitle": "სისტემაში შესვლა",
      "email": "ელ-ფოსტა",
      "password": "პაროლი",
      "loginButton": "შესვლა",
      "loggingIn": "შესვლა...",
      "testCredentials": "ტესტური მონაცემები:",
      "admin": "ადმინისტრატორი",
      "client": "კლიენტი",
      
      // Footer
      "privacyPolicy": "კონფიდენციალურობის პოლიტიკა",
      "allRightsReserved": "ყველა უფლება დაცულია",
      
      // Common
      "loading": "იტვირთება...",
      "error": "შეცდომა",
      "success": "წარმატება",
      "save": "შენახვა",
      "cancel": "გაუქმება",
      "delete": "წაშლა",
      "edit": "რედაქტირება",
      "add": "დამატება",
      "search": "ძებნა",
      "filter": "ფილტრი",
      "sort": "დალაგება",
      "price": "ფასი",
      "quantity": "რაოდენობა",
      "description": "აღწერა",
      "category": "კატეგორია",
      "status": "სტატუსი",
      "actions": "მოქმედებები",
      "confirm": "დადასტურება",
      "close": "დახურვა",
      
      // Product Details
      "productDetails": "პროდუქტის დეტალები",
      "addToCart": "კალათაში დამატება",
      "inStock": "მარაგშია",
      "outOfStock": "არ არის მარაგში",
      "selectUnit": "აირჩიეთ ერთეული",
      "perPiece": "ცალი",
      "perBox": "ყუთი",
      "discount": "ფასდაკლება",
      "originalPrice": "საწყისი ფასი",
      "finalPrice": "საბოლოო ფასი",
      
      // Orders
      "myOrders": "ჩემი შეკვეთები",
      "orderNumber": "შეკვეთა №",
      "orderDate": "შეკვეთის თარიღი",
      "orderStatus": "სტატუსი",
      "orderTotal": "თანხა",
      "viewDetails": "დეტალების ნახვა",
      "orderDetails": "შეკვეთის დეტალები",
      "deliveryAddress": "მიწოდების მისამართი",
      "deliveryDate": "მიწოდების თარიღი",
      "orderItems": "შეკვეთის პროდუქტები",
      "itemsCount": "პროდუქტების რაოდენობა",
      
      // Order Statuses
      "pending": "მოლოდინში",
      "confirmed": "დადასტურებული",
      "processing": "მუშავდება",
      "shipped": "გაგზავნილი",
      "delivered": "მიწოდებული",
      "cancelled": "გაუქმებული",
      
      // Checkout
      "checkoutTitle": "შეკვეთის გაფორმება",
      "deliveryInfo": "მიწოდების ინფორმაცია",
      "deliveryDateLabel": "მიწოდების თარიღი",
      "deliveryAddressLabel": "მიწოდების მისამართი",
      "notes": "შენიშვნები",
      "orderSummary": "შეკვეთის რეზიუმე",
      "subtotal": "შუალედური ჯამი",
      "deliveryFee": "მიწოდება",
      "placeOrder": "შეკვეთის განთავსება",
      "yourOrder": "თქვენი შეკვეთა",
      "deliveryDetails": "მიწოდების დეტალები",
      "additionalInfo": "დამატებითი ინფორმაცია",
      "orderComments": "შეკვეთის კომენტარები...",
      "selectDate": "აირჩიეთ თარიღი",
      "submitting": "გაგზავნა...",
      "submitOrder": "შეკვეთის გაგზავნა",
      
      // Profile
      "myProfile": "ჩემი პროფილი",
      "restaurantName": "რესტორნის სახელი",
      "contactPerson": "საკონტაქტო პირი",
      "phone": "ტელეფონი",
      "address": "მისამართი",
      "updateProfile": "პროფილის განახლება",
      "changePassword": "პაროლის შეცვლა",
      "currentPassword": "მიმდინარე პაროლი",
      "newPassword": "ახალი პაროლი",
      "confirmPassword": "დაადასტურეთ პაროლი",
      
      // Admin Dashboard
      "adminDashboard": "ადმინისტრატორის პანელი",
      "statistics": "სტატისტიკა",
      "totalOrders": "სულ შეკვეთები",
      "totalRevenue": "მთლიანი შემოსავალი",
      "totalProducts": "სულ პროდუქტები",
      "totalUsers": "სულ მომხმარებლები",
      "recentOrders": "ბოლო შეკვეთები",
      "topProducts": "პოპულარული პროდუქტები",
      
      // Admin Products
      "manageProducts": "პროდუქტების მართვა",
      "addProduct": "პროდუქტის დამატება",
      "editProduct": "პროდუქტის რედაქტირება",
      "deleteProduct": "პროდუქტის წაშლა",
      "productName": "პროდუქტის სახელი",
      "productImage": "პროდუქტის სურათი",
      "productPrice": "ფასი",
      "productStock": "მარაგი",
      "productCategory": "კატეგორია",
      "productActive": "აქტიური",
      "uploadImage": "სურათის ატვირთვა",
      "searchProducts2": "პროდუქტების ძებნა...",
      "importCategories": "კატეგორიების იმპორტი",
      "importProducts": "პროდუქტების იმპორტი",
      "image": "სურათი",
      "name": "სახელი",
      "sortByDiscount": "დალაგება ფასდაკლებით",
      "sortByPopularity": "პოპულარობით",
      "sortByStock": "მარაგით",
      "popularity": "პოპულარობა",
      "stock": "მარაგი",
      "unit": "ერთეული",
      "allCategories": "ყველა კატეგორია",
      
      // Admin Orders
      "manageOrders": "შეკვეთების მართვა",
      "updateStatus": "სტატუსის განახლება",
      "orderHistory": "შეკვეთების ისტორია",
      "customer": "კლიენტი",
      "paymentStatus": "გადახდის სტატუსი",
      "paid": "გადახდილი",
      "unpaid": "გადაუხდელი",
      "searchOrders": "ძებნა ნომრით ან კლიენტით...",
      "orderNumber2": "ნომერი",
      "createdDate": "შექმნის თარიღი",
      "delivery": "მიწოდება",
      "itemsCount2": "პროდუქტები",
      "amount": "თანხა",
      "viewDetails2": "დეტალები",
      "changeStatus": "სტატუსის შეცვლა",
      "changeOrderStatus": "შეკვეთის სტატუსის შეცვლა #",
      "currentStatus": "მიმდინარე სტატუსი",
      "newStatus": "ახალი სტატუსი",
      "commentOptional": "კომენტარი (არასავალდებულო)",
      "allOrders": "ყველა შეკვეთა",
      "pendingOrders": "დადასტურების მოლოდინში",
      "confirmedOrders": "დადასტურებული",
      "processingOrders": "მუშავდება",
      "completedOrders": "დასრულებული",
      "cancelledOrders": "გაუქმებული",
      "rejectedOrders": "უარყოფილი",
      
      // Admin Users
      "manageUsers": "კლიენტების მართვა",
      "addUser": "კლიენტის დამატება",
      "editUser": "კლიენტის რედაქტირება",
      "deleteUser": "კლიენტის წაშლა",
      "userName": "სახელი",
      "userEmail": "ელ-ფოსტა",
      "userRole": "როლი",
      "userStatus": "სტატუსი",
      "active": "აქტიური",
      "inactive": "არააქტიური",
      "personalDiscount": "პერსონალური ფასდაკლება",
      
      // Validation Messages
      "fieldRequired": "ეს ველი სავალდებულოა",
      "invalidEmail": "არასწორი ელ-ფოსტის მისამართი",
      "passwordTooShort": "პაროლი უნდა იყოს მინიმუმ 6 სიმბოლო",
      "passwordsNotMatch": "პაროლები არ ემთხვევა",
      "invalidPrice": "არასწორი ფასი",
      "invalidQuantity": "არასწორი რაოდენობა",
      
      // Success Messages
      "productAdded": "პროდუქტი დაემატა კალათას",
      "orderPlaced": "შეკვეთა განთავსდა",
      "profileUpdated": "პროფილი განახლდა",
      "passwordChanged": "პაროლი შეიცვალა",
      "productCreated": "პროდუქტი შეიქმნა",
      "productUpdated": "პროდუქტი განახლდა",
      "productDeleted": "პროდუქტი წაიშალა",
      
      // Error Messages
      "generalError": "რაღაც შეცდომა მოხდა",
      "networkError": "ქსელის შეცდომა",
      "unauthorized": "არაავტორიზებული წვდომა",
      "notFound": "ვერ მოიძებნა",
      "serverError": "სერვერის შეცდომა"
    }
  },
  hi: {
    translation: {
      // Header
      "catalog": "सूची",
      "categories": "श्रेणियाँ",
      "allProducts": "सभी उत्पाद",
      "orders": "आदेश",
      "dashboard": "डैशबोर्ड",
      "products": "उत्पाद",
      "clients": "ग्राहक",
      "cart": "कार्ट",
      "profile": "प्रोफ़ाइल",
      "logout": "लॉग आउट",
      "login": "लॉग इन",
      "basicInfo": "मूल जानकारी",
      "addBox": "बॉक्स जोड़ें",
      "yourPersonalDiscountApplied": "आपकी व्यक्तिगत छूट लागू की गई है",
      "generalDiscountApplied": "सामान्य छूट लागू की गई है",
      "yourPersonalDiscount": "आपकी व्यक्तिगत छूट",
      "yourPersonalDiscountUnit": "आपकी व्यक्तिगत छूट प्रति इकाई",
      "generalDiscount": "सामान्य छूट",
      "orderInfo": "आदेश जानकारी",
      "backToOrders": "आदेशों पर वापस",
      "contact": "संपर्क",
      "productsInOrder": "आदेशित उत्पाद",
      "waitsForConfirmation": "पुष्टि की प्रतीक्षा कर रहा है",
      "language": "hi",
      "item": "उत्पाद",
      "statusHistory": "स्थिति इतिहास",
      "orderPlacedSuccess": "आदेश सफलतापूर्वक रखा गया",
      "orderEditedByAdmin": "आदेश को प्रशासक द्वारा संपादित किया गया",
      "subTotal": "उप-योग",
      "order": "आदेश",
      "city": "शहर",
      "postalCode": "पिन कोड",
      "country": "देश",
      "firstName": "पहला नाम",
      "lastName": "अंतिम नाम",
      "deliveryRules": "वितरण नियम",
      "deliveryDays": "वितरण दिन",
      "monday": "सोमवार",
      "tuesday": "मंगलवार",
      "wednesday": "बुधवार",
      "thursday": "गुरुवार",
      "friday": "शुक्रवार",
      "saturday": "शनिवार",
      "sunday": "रविवार",
      "security": "सुरक्षा",
      "noDescription": "कोई विवरण नहीं",
      "nutritionalValue": "पोषण मूल्य",
      "back": "पीछे",
      "calories": "कैलोरी",
      "protein": "प्रोटीन",
      "fat": "वसा",
      "carbohydrates": "कार्बोहाइड्रेट",
      "fiber": "फाइबर",
      "servingSize": "सर्विंग साइज",
      "caloriesUnit": "kcal",
      "g": "g",
      "completed": "पूर्ण",
      "rejected": "अस्वीकृत",
      "repeatOrder": "आदेश दोहराएं",
      "boxSales": "बॉक्स बिक्री",
      "inBox": "बॉक्स में",
      "boxPrice": "बॉक्स की कीमत",
      "boxQuantity": "बॉक्स की मात्रा",
      "noOrders": "आपके पास अभी तक कोई आदेश नहीं है",
      "inCart": "कार्ट में",
      "loginError": "लॉग इन विफल हुआ",
      "invalidCredentials": "अमान्य संजात डेटा",
      "errorLoadingOrders": "आदेश लोड करने में त्रुटि",
      // Catalog
      "productCatalog": "उत्पाद सूची",
      "searchProducts": "उत्पाद खोजें...",
      "sortByName": "नाम से",
      "sortByPriceAsc": "कीमत: बढ़ती",
      "sortByPriceDesc": "कीमत: घटती",
      "loadingProducts": "उत्पाद लोड हो रहे हैं...",
      "noProductsFound": "कोई उत्पाद नहीं मिला",
      "errorLoadingProducts": "उत्पाद लोड करने में त्रुटि",
      
      // Cart
      "yourCart": "आपका कार्ट",
      "cartEmpty": "आपका कार्ट खाली है",
      "addFromCatalog": "सूची से उत्पाद जोड़ें",
      "goToCatalog": "सूची पर जाएं",
      "clearCart": "कार्ट खाली करें",
      "itemsInCart": "कार्ट में उत्पाद:",
      "total": "कुल:",
      "checkout": "चेकआउट",
      "remove": "हटाएं",
      "box": "बॉक्स",
      "pieces": "टुकड़े",
      "minimumOrderWarning": "न्यूनतम ऑर्डर राशि: {{amount}}€",
      "addMoreProducts": "{{amount}}€ और जोड़ें",
      "priceDisclaimer": "अंतिम कीमत पैकेजिंग के आधार पर भिन्न हो सकती है.<br/>कुल राशि में वैट जोड़ा जाता है।",
      "orderHasNoItems": "ऑर्डर में कोई उत्पाद नहीं है",
      "addedToCart": "कार्ट में जोड़ा गया",
      "items": "आइटम",
      "unavailable": "अनुपलब्ध",
      "allItemsUnavailable": "दुर्भाग्य से, ऑर्डर के सभी उत्पाद वर्तमान में अनुपलब्ध हैं",
      "repeatOrderFailed": "ऑर्डर दोहराने में विफल",
      
      // Units
      "kg": "किग्रा",
      "piece": "टुकड़ा",
      "boxUnit": "बॉक्स",
      
      // Login
      "welcomeMessage": "रेस्तरां के लिए खाद्य परिवहन",
      "loginTitle": "सिस्टम में लॉग इन करें",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "loginButton": "लॉग इन",
      "loggingIn": "लॉग इन हो रहा है...",
      "testCredentials": "टेस्ट क्रेडेंशियल्स:",
      "admin": "व्यवस्थापक",
      "client": "ग्राहक",
      
      // Footer
      "privacyPolicy": "गोपनीयता नीति",
      "allRightsReserved": "सर्वाधिकार सुरक्षित",
      
      // Common
      "loading": "लोड हो रहा है...",
      "error": "त्रुटि",
      "success": "सफलता",
      "save": "सहेजें",
      "cancel": "रद्द करें",
      "delete": "हटाएं",
      "edit": "संपादित करें",
      "add": "जोड़ें",
      "search": "खोजें",
      "filter": "फ़िल्टर",
      "sort": "क्रमबद्ध करें",
      "price": "कीमत",
      "quantity": "मात्रा",
      "description": "विवरण",
      "category": "श्रेणी",
      "status": "स्थिति",
      "actions": "कार्रवाई",
      "confirm": "पुष्टि करें",
      "close": "बंद करें",
      
      // Product Details
      "productDetails": "उत्पाद विवरण",
      "addToCart": "कार्ट में जोड़ें",
      "inStock": "स्टॉक में",
      "outOfStock": "स्टॉक से बाहर",
      "selectUnit": "इकाई चुनें",
      "perPiece": "प्रति टुकड़ा",
      "perBox": "प्रति बॉक्स",
      "discount": "छूट",
      "originalPrice": "मूल कीमत",
      "finalPrice": "अंतिम कीमत",
      
      // Orders
      "myOrders": "मेरे आदेश",
      "orderNumber": "आदेश संख्या",
      "orderDate": "आदेश तिथि",
      "orderStatus": "स्थिति",
      "orderTotal": "कुल",
      "viewDetails": "विवरण देखें",
      "orderDetails": "आदेश विवरण",
      "deliveryAddress": "वितरण पता",
      "deliveryDate": "वितरण तिथि",
      "orderItems": "आदेशित उत्पाद",
      "itemsCount": "उत्पादों की संख्या",
      
      // Order Statuses
      "pending": "लंबित",
      "confirmed": "पुष्टि की गई",
      "processing": "प्रसंस्करण में",
      "shipped": "भेजा गया",
      "delivered": "वितरित",
      "cancelled": "रद्द",
      
      // Checkout
      "checkoutTitle": "आदेश पूरा करना",
      "deliveryInfo": "वितरण जानकारी",
      "deliveryDateLabel": "वितरण तिथि",
      "deliveryAddressLabel": "वितरण पता",
      "notes": "नोट्स",
      "orderSummary": "आदेश सारांश",
      "subtotal": "उप-योग",
      "deliveryFee": "वितरण शुल्क",
      "placeOrder": "आदेश रखें",
      "yourOrder": "आपका आदेश",
      "deliveryDetails": "वितरण विवरण",
      "additionalInfo": "अतिरिक्त जानकारी",
      "orderComments": "आदेश टिप्पणियाँ...",
      "selectDate": "तारीख चुनें",
      "submitting": "सबमिट कर रहे हैं...",
      "submitOrder": "आदेश सबमिट करें",
      
      // Profile
      "myProfile": "मेरा प्रोफ़ाइल",
      "restaurantName": "रेस्तरां का नाम",
      "contactPerson": "संपर्क व्यक्ति",
      "phone": "फ़ोन",
      "address": "पता",
      "updateProfile": "प्रोफ़ाइल अपडेट करें",
      "changePassword": "पासवर्ड बदलें",
      "currentPassword": "वर्तमान पासवर्ड",
      "newPassword": "नया पासवर्ड",
      "confirmPassword": "पासवर्ड की पुष्टि करें",
      "street": "सड़क",
      
      // Admin Dashboard
      "adminDashboard": "व्यवस्थापक डैशबोर्ड",
      "statistics": "सांख्यिकी",
      "totalOrders": "कुल आदेश",
      "totalRevenue": "कुल राजस्व",
      "totalProducts": "कुल उत्पाद",
      "totalUsers": "कुल उपयोगकर्ता",
      "recentOrders": "हाल के आदेश",
      "topProducts": "लोकप्रिय उत्पाद",
      
      // Admin Products
      "manageProducts": "उत्पाद प्रबंधित करें",
      "addProduct": "उत्पाद जोड़ें",
      "editProduct": "उत्पाद संपादित करें",
      "deleteProduct": "उत्पाद हटाएं",
      "productName": "उत्पाद नाम",
      "productImage": "उत्पाद छवि",
      "productPrice": "कीमत",
      "productStock": "स्टॉक",
      "productCategory": "श्रेणी",
      "productActive": "सक्रिय",
      "uploadImage": "छवि अपलोड करें",
      "searchProducts2": "उत्पाद खोजें...",
      "importCategories": "श्रेणियाँ आयात करें",
      "importProducts": "उत्पाद आयात करें",
      "image": "छवि",
      "name": "नाम",
      "sortByDiscount": "छूट से क्रमबद्ध करें",
      "sortByPopularity": "लोकप्रियता से क्रमबद्ध करें",
      "sortByStock": "स्टॉक से क्रमबद्ध करें",
      "popularity": "लोकप्रियता",
      "stock": "स्टॉक",
      "unit": "इकाई",
      "allCategories": "सभी श्रेणियाँ",
      
      // Admin Orders
      "manageOrders": "आदेश प्रबंधित करें",
      "updateStatus": "स्थिति अपडेट करें",
      "orderHistory": "आदेश इतिहास",
      "customer": "ग्राहक",
      "paymentStatus": "भुगतान स्थिति",
      "paid": "भुगतान किया गया",
      "unpaid": "अभुगतान",
      "searchOrders": "संख्या या ग्राहक द्वारा खोजें...",
      "orderNumber2": "संख्या",
      "createdDate": "निर्माण तिथि",
      "delivery": "वितरण",
      "itemsCount2": "आइटम",
      "amount": "राशि",
      "viewDetails2": "विवरण देखें",
      "changeStatus": "स्थिति बदलें",
      "changeOrderStatus": "आदेश स्थिति बदलें #",
      "currentStatus": "वर्तमान स्थिति",
      "newStatus": "नई स्थिति",
      "commentOptional": "टिप्पणी (वैकल्पिक)",
      "allOrders": "सभी आदेश",
      "pendingOrders": "पुष्टि की प्रतीक्षा में",
      "confirmedOrders": "पुष्टि की गई",
      "processingOrders": "प्रसंस्करण में",
      "completedOrders": "पूर्ण",
      "cancelledOrders": "रद्द",
      "rejectedOrders": "अस्वीकृत",
      
      // Admin Users
      "manageUsers": "ग्राहकों को प्रबंधित करें",
      "addUser": "ग्राहक जोड़ें",
      "editUser": "ग्राहक संपादित करें",
      "deleteUser": "ग्राहक हटाएं",
      "userName": "नाम",
      "userEmail": "ईमेल",
      "userRole": "भूमिका",
      "userStatus": "स्थिति",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "personalDiscount": "व्यक्तिगत छूट",
      
      // Validation Messages
      "fieldRequired": "यह फ़ील्ड आवश्यक है",
      "invalidEmail": "अमान्य ईमेल पता",
      "passwordTooShort": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
      "passwordsNotMatch": "पासवर्ड मेल नहीं खाते",
      "invalidPrice": "अमान्य कीमत",
      "invalidQuantity": "अमान्य मात्रा",
      
      // Success Messages
      "productAdded": "उत्पाद कार्ट में जोड़ा गया",
      "orderPlaced": "आदेश रखा गया",
      "profileUpdated": "प्रोफ़ाइल अपडेट किया गया",
      "passwordChanged": "पासवर्ड बदल दिया गया",
      "productCreated": "उत्पाद बनाया गया",
      "productUpdated": "उत्पाद अपडेट किया गया",
      "productDeleted": "उत्पाद हटाया गया",
      
      // Error Messages
      "generalError": "कुछ गलत हो गया",
      "networkError": "नेटवर्क त्रुटि",
      "unauthorized": "अनधिकृत पहुंच",
      "notFound": "नहीं मिला",
      "serverError": "सर्वर त्रुटि"
    }
  }
};

// Separate resources for categories by code
const categoryResources = {
  "et": {
    "translation": {
      "1": "Sealiha külmutatud",
      "2": "Veiseliha Külmutatud",
      "3": "Lambaliha",
      "3.1": "Lambaliha kondiga Külmutatud",
      "3.2": "Lambaliha filee Külmutatud",
      "4": "Kanaliha toodet Külmutatud",
      "4.1": "Kintsuliha Külmutatud",
      "4.2": "Koib, kints Külmutatud",
      "4.3": "Tiib Külmutatud",
      "4.4": "Filee Külmutatud",
      "4.5": "Broiler",
      "4.6": "Süda, maks",
      "5": "Kalkuniliha Külmutatud",
      "6": "PART Külmutatud",
      "6.1": "Pardili filee Külmutatud",
      "6.2": "Part kondiga Külmutatud",
      "7": "Hakkliha Külmutatud",
      "8": "Guljašš, strooganov, kuubikud (Külmutatud)",
      "9": "Kebab ( Külmutatud)",
      "10": "Kanaliha Jahutatud",
      "11": "Mereannid",
      "11.1": "Krevetid koorega",
      "11.2": "Krevetid kooritud",
      "12": "Kala / mereannid",
      "12.1": "Kala, kalafileed",
      "12.2": "Mereannid",
      "12.3": "Paneeritud kala ja mereanni tooted",
      "13": "Friikartul",
      "14": "Köögiviljad",
      "14.1": "Maitsetaimed",
      "15": "Marjad",
      "16": "Seened",
      "17": "Külmutatud lihatooted ja poolfabrikaadid",
      "18": "Suupisted Külmutatud",
      "19": "Pagaritooted",
      "20": "Jäätis",
      "21": "Koor, piim",
      "22": "Majonees",
      "23": "Toidu ja fritüürõlid",
      "24": "Või",
      "25": "Juust",
      "26": "Toorjuust",
      "27": "Tomati kastmed",
      "28": "Konserveeritud köögiviljad ja puuviljad",
      "29": "Valmis lihatooted",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "en": {
    "translation": {
      "1": "Frozen Pork",
      "2": "Frozen Beef",
      "3": "Lamb Meat",
      "3.1": "Frozen Lamb with Bone",
      "3.2": "Frozen Lamb Fillet",
      "4": "Frozen Chicken Products",
      "4.1": "Frozen Chicken Thigh",
      "4.2": "Frozen Breast, Thigh",
      "4.3": "Frozen Wing",
      "4.4": "Frozen Fillet",
      "4.5": "Broiler",
      "4.6": "Heart, Liver",
      "5": "Frozen Turkey Meat",
      "6": "Duck Frozen",
      "6.1": "Frozen Duck Fillet",
      "6.2": "Frozen Duck with Bone",
      "7": "Frozen Minced Meat",
      "8": "Goulash, Stroganoff, Cubes (Frozen)",
      "9": "Kebab (Frozen)",
      "10": "Chilled Chicken Meat",
      "11": "Seafood",
      "11.1": "Shrimp with Shell",
      "11.2": "Peeled Shrimp",
      "12": "Fish / Seafood",
      "12.1": "Fish, Fish Fillets",
      "12.2": "Seafood",
      "12.3": "Breaded Fish and Seafood Products",
      "13": "French Fries",
      "14": "Vegetables",
      "14.1": "Herbs",
      "15": "Berries",
      "16": "Mushrooms",
      "17": "Frozen Meat Products and Semi-Finished Products",
      "18": "Frozen Snacks",
      "19": "Bakery Products",
      "20": "Ice Cream",
      "21": "Cream, Milk",
      "22": "Mayonnaise",
      "23": "Cooking and Frying Oils",
      "24": "Butter",
      "25": "Cheese",
      "26": "Cream Cheese",
      "27": "Tomato Sauces",
      "28": "Canned Vegetables and Fruits",
      "29": "Ready Meat Products",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "ru": {
    "translation": {
      "1": "Замороженная свинина",
      "2": "Замороженная говядина",
      "3": "Баранина",
      "3.1": "Замороженная баранина с костью",
      "3.2": "Замороженное филе баранины",
      "4": "Замороженные продукты из курицы",
      "4.1": "Замороженное куриное бедро",
      "4.2": "Замороженная грудка, бедро",
      "4.3": "Замороженное крыло",
      "4.4": "Замороженное филе",
      "4.5": "Бройлер",
      "4.6": "Сердце, печень",
      "5": "Замороженное мясо индейки",
      "6": "Утка замороженная",
      "6.1": "Замороженное филе утки",
      "6.2": "Замороженная утка с костью",
      "7": "Замороженный фарш",
      "8": "Гуляш, строганов, кубики (замороженные)",
      "9": "Кебаб (замороженный)",
      "10": "Охлажденное куриное мясо",
      "11": "Морепродукты",
      "11.1": "Креветки с панцирем",
      "11.2": "Очищенные креветки",
      "12": "Рыба / морепродукты",
      "12.1": "Рыба, рыбные филе",
      "12.2": "Морепродукты",
      "12.3": "Панированные продукты из рыбы и морепродуктов",
      "13": "Картофель фри",
      "14": "Овощи",
      "14.1": "Специи",
      "15": "Ягоды",
      "16": "Грибы",
      "17": "Замороженные мясные продукты и полуфабрикаты",
      "18": "Замороженные закуски",
      "19": "Пекарские изделия",
      "20": "Мороженое",
      "21": "Сливки, молоко",
      "22": "Майонез",
      "23": "Пищевые и жареные масла",
      "24": "Масло",
      "25": "Сыр",
      "26": "Творожный сыр",
      "27": "Томатные соусы",
      "28": "Консервированные овощи и фрукты",
      "29": "Готовые мясные продукты",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "az": {
    "translation": {
      "1": "Dondurulmuş xınzir əti",
      "2": "Dondurulmuş mal əti",
      "3": "Qoyun əti",
      "3.1": "Sümükülü qoyun əti",
      "3.2": "Dondurulmuş qoyun file",
      "4": "Dondurulmuş toyuq məhsulları",
      "4.1": "Dondurulmuş toyuq budu",
      "4.2": "Dondurulmuş göğs, bud",
      "4.3": "Dondurulmuş qanad",
      "4.4": "Dondurulmuş file",
      "4.5": "Broiler",
      "4.6": "Ürək, cəyər",
      "5": "Dondurulmuş kurku əti",
      "6": "Dondurulmuş öküz",
      "6.1": "Dondurulmuş öküz file",
      "6.2": "Sümükülü öküz",
      "7": "Dondurulmuş qiymə",
      "8": "Gulash, stroganoff, kubiklar (dondurulmuş)",
      "9": "Kabab (dondurulmuş)",
      "10": "Soyudulmuş toyuq əti",
      "11": "Dəniz məhsulları",
      "11.1": "Qabığı ilə karid",
      "11.2": "Təmizlənmiş karid",
      "12": "Balıq / dəniz məhsulları",
      "12.1": "Balıq, balıq file",
      "12.2": "Dəniz məhsulları",
      "12.3": "Çörəkli balıq və dəniz məhsulları",
      "13": "Fransız kartof",
      "14": "Sabziler",
      "14.1": "Ədviyyatlar",
      "15": "Qoz",
      "16": "Göbələk",
      "17": "Dondurulmuş ət məhsulları və yarıfərqli məhsullar",
      "18": "Dondurulmuş atıştırmalıqlar",
      "19": "Nəxərçilik məhsulları",
      "20": "Muzqofte",
      "21": "Krem, süd",
      "22": "Mayonez",
      "23": "Qida və qızartma yağları",
      "24": "Yağ",
      "25": "Pəhli",
      "26": "Krem pəhli",
      "27": "Pomidor sousları",
      "28": "Qonservelənmiş tərəvəz və meyvələr",
      "29": "Hazır ət məhsulları",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "hy": {
    "translation": {
      "1": "Փակցված խոզի միս",
      "2": "Փակցված սովորական միս",
      "3": "Ոչխարի միս",
      "3.1": "Փակցված ոսկորով ոչխարի միս",
      "3.2": "Փակցված ոչխարի ֆիլե",
      "4": "Փակցված հավի արտադրանք",
      "4.1": "Փակցված հավի բերան",
      "4.2": "Փակցված կրծքամաս, բերան",
      "4.3": "Փակցված թև",
      "4.4": "Փակցված ֆիլե",
      "4.5": "Բրոյլեր",
      "4.6": "Σerdce, pechen'",
      "5": "Փակցված հնդկահավի միս",
      "6": "Փակցված կարապ",
      "6.1": "Փակցված կարապի ֆիլե",
      "6.2": "Փակցված ոսկորով կարապ",
      "7": "Փակցված հ hacks",
      "8": "Գուլյաշ, ստրոգանով, խորանարդներ (փակցված)",
      "9": "Քյաբաբ (փակցված)",
      "10": "Մսացրած հավի միս",
      "11": "Ծովամթերք",
      "11.1": "Խնձորով ծովաբազուկ",
      "11.2": "Մաքրված ծովաբազուկ",
      "12": "Բալուկ / ծովամթերք",
      "12.1": "Բալուկ, բալուկի ֆիլե",
      "12.2": "Ծովամթերք",
      "12.3": "Պանրով ծածկված բալուկի և ծովամթերքի արտադրանք",
      "13": "Ֆրանսիական կարտոֆիլ",
      "14": "Բանջարեղեն",
      "14.1": "Խոտաբույսեր",
      "15": "Հոնէք",
      "16": "Սնկեր",
      "17": "Փակցված մսային արտադրանք և կիսաֆաբրիկատներ",
      "18": "Փակցված թխվածքներ",
      "19": "Նուխ արտադրանք",
      "20": "Մրգային սեր",
      "21": "Կրեմ, կաթ",
      "22": "Մայոնեզ",
      "23": "Ուտելի և տապակված յուղեր",
      "24": "Մարմար",
      "25": "Գդալ",
      "26": "Կրեմ պանր",
      "27": "Նուշիկի սոուսներ",
      "28": "Կոնսերվացված բանջարեղեն և մրգեր",
      "29": "Պատրաստի մսային արտադրանք",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "ka": {
    "translation": {
      "1": "გაყინული ღორის ხორცი",
      "2": "გაყინული ხბო",
      "3": "ნამცხვრის ხორცი",
      "3.1": "გაყინული ძვლით ნამცხვრის ხორცი",
      "3.2": "გაყინული ნამცხვრის ფილე",
      "4": "გაყინული ქათმის პროდუქტები",
      "4.1": "გაყინული ქათმის ბუმბული",
      "4.2": "გაყინული სარძევი, ბუმბული",
      "4.3": "გაყინული ფრთა",
      "4.4": "გაყინული ფილე",
      "4.5": "ბროილერი",
      "4.6": "გული, ღვიძლი",
      "5": "გაყინული ინდაურის ხორცი",
      "6": "გაყინული იხვი",
      "6.1": "გაყინული იხვის ფილე",
      "6.2": "გაყინული ძვლით იხვი",
      "7": "გაყინული შემწუხებელი ხორცი",
      "8": "გულაში, სტროგანოვი, კუბები (გაყინული)",
      "9": "კებაბი (გაყინული)",
      "10": "გაგრილი ქათმის ხორცი",
      "11": "ზღვის პროდუქტები",
      "11.1": "გლუვი კარაპუსით კრევეტები",
      "11.2": "გლუვი კარაპუსის გარეშე კრევეტები",
      "12": "თევზი / ზღვის პროდუქტები",
      "12.1": "თევზი, თევზის ფილე",
      "12.2": "ზღვის პროდუქტები",
      "12.3": "პანირებული თევზის და ზღვის პროდუქტები",
      "13": "ფრანგული კარტოფილი",
      "14": "ბოსტნეული",
      "14.1": "ჩანაფიქრები",
      "15": "ნაყინი",
      "16": "სოკო",
      "17": "გაყინული ხორცის პროდუქტები და ნახევარფაბრიკატები",
      "18": "გაყინული საჭმელები",
      "19": "ცხობის პროდუქტები",
      "20": "ცხარე",
      "21": "ხაჭო, რძე",
      "22": "მაიონეზი",
      "23": "საკვები და შემწვარი ზეთები",
      "24": "ხარშა",
      "25": "მწიღვნე",
      "26": "ხაჭაპურის ყველი",
      "27": "ვარდის შემწელი",
      "28": "კონსერვირებული ბოსტნეული და ხილი",
      "29": "მზა ხორცის პროდუქტები",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "it": {
    "translation": {
      "1": "Maiale congelato",
      "2": "Manzo congelato",
      "3": "Carne di agnello",
      "3.1": "Agnello congelato con osso",
      "3.2": "Filetto di agnello congelato",
      "4": "Prodotti di pollo congelati",
      "4.1": "Coscia di pollo congelata",
      "4.2": "Petto, coscia congelati",
      "4.3": "Ala congelata",
      "4.4": "Filetto congelato",
      "4.5": "Broiler",
      "4.6": "Cuore, fegato",
      "5": "Carne di tacchino congelata",
      "6": "Anatra congelata",
      "6.1": "Filetto di anatra congelato",
      "6.2": "Anatra congelata con osso",
      "7": "Carne macinata congelata",
      "8": "Gulasch, Stroganoff, Cubetti (Congelati)",
      "9": "Kebab (Congelato)",
      "10": "Carne di pollo refrigerata",
      "11": "Frutti di mare",
      "11.1": "Gamberetti con guscio",
      "11.2": "Gamberetti sgusciati",
      "12": "Pesce / Frutti di mare",
      "12.1": "Pesce, Filetti di pesce",
      "12.2": "Frutti di mare",
      "12.3": "Prodotti di pesce e frutti di mare impanati",
      "13": "Patatine fritte",
      "14": "Verdure",
      "14.1": "Erbe aromatiche",
      "15": "Frutti di bosco",
      "16": "Funghi",
      "17": "Prodotti di carne congelati e semilavorati",
      "18": "Snack congelati",
      "19": "Prodotti da forno",
      "20": "Gelato",
      "21": "Panna, latte",
      "22": "Maionese",
      "23": "Oli alimentari e per frittura",
      "24": "Burro",
      "25": "Formaggio",
      "26": "Formaggio cremoso",
      "27": "Salse di pomodoro",
      "28": "Verdure e frutta in conserva",
      "29": "Prodotti di carne pronti",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  },
  "hi": {
    "translation": {
      "1": "जमे हुए सूअर का मांस",
      "2": "जमे हुए गोमांस",
      "3": "मेमना",
      "3.1": "हड्डी के साथ जमे हुए मेमना",
      "3.2": "जमे हुए मेमने का फ़िलेट",
      "4": "मुर्गी के जमे हुए उत्पाद",
      "4.1": "जमे हुए मुर्गी की जांघ",
      "4.2": "जमे हुए ब्रेस्ट, जांघ",
      "4.3": "जमे हुए पंख",
      "4.4": "जमे हुए फ़िलेट",
      "4.5": "ब्रॉयलर",
      "4.6": "दिल, लीवर",
      "5": "टर्की के जमे हुए मांस",
      "6": "जमे हुए बत्तख",
      "6.1": "जमे हुए बत्तख का फ़िलेट",
      "6.2": "हड्डी के साथ जमे हुए बत्तख",
      "7": "जमे हुए कीमा",
      "8": "गुलाश, स्ट्रोगनॉफ़, क्यूब्स (जमे हुए)",
      "9": "कबाब (जमे हुए)",
      "10": "ठंडा किया हुआ मुर्गी का मांस",
      "11": "समुद्री उत्पाद",
      "11.1": "छिलके के साथ झींगा",
      "11.2": "छिले हुए झींगा",
      "12": "मछली / समुद्री उत्पाद",
      "12.1": "मछली, मछली के फ़िलेट",
      "12.2": "समुद्री उत्पाद",
      "12.3": "मछली और समुद्री उत्पादों के ब्रेडेड उत्पाद",
      "13": "फ़्रेंच फ्राइज़",
      "14": "सब्जियाँ",
      "14.1": "मसाले",
      "15": "बेरीज़",
      "16": "मशरूम",
      "17": "जमे हुए मांस उत्पाद और अर्ध-तैयार उत्पाद",
      "18": "जमे हुए स्नैक्स",
      "19": "बेकरी उत्पाद",
      "20": "आइसक्रीम",
      "21": "क्रीम, दूध",
      "22": "मेयोनेज़",
      "23": "खाद्य और फ्राइंग तेल",
      "24": "मक्खन",
      "25": "पनीर",
      "26": "कॉटेज चीज़",
      "27": "टमाटर सॉस",
      "28": "कैन किए हुए सब्जियाँ और फल",
      "29": "तैयार मांस उत्पाद",
      "29.1": "DAIVIDA",
      "29.2": "FOREVERS",
      "29.3": "KABO",
      "29.4": "LUKOZ"
    }
  }
};

// Merge resources and categoryResources
const mergedResources = {};
const supportedLanguages = ['et', 'en', 'ru', 'az', 'hy', 'ka', 'it', 'hi'];

supportedLanguages.forEach(lang => {
  mergedResources[lang] = {
    translation: {
      ...(resources[lang]?.translation || {}),
      ...(categoryResources[lang]?.translation || {})
    }
  };
});

// Language detection options
const detectionOptions = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: mergedResources,
    fallbackLng: 'et',
    supportedLngs: supportedLanguages,
    detection: detectionOptions,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Check if detected language is supported, if not use Estonian
const detectedLang = i18n.language;
if (!supportedLanguages.includes(detectedLang)) {
  i18n.changeLanguage('et');
}

export default i18n;

